import React, { useState, useEffect, useRef } from 'react';
import classes from './HeaderNav.module.css';
import logo from '../../../Assets/rotating-logo.png';
import icon from '../../../Assets/Component 1 (4).png';
import iconinactive from '../../../Assets/dshbrd-inactive.png';
import trsanstin from '../../../Assets/cardtrsnct.png';
import RotatingLogo from '../../../Assets/rotating-logo.png'
import trsanstinactive from '../../../Assets/Component 1 (3).png';
import acctn from '../../../Assets/Accountingicon.png';
import acctnactive from '../../../Assets/Component 1 (2).png';
import rprts from '../../../Assets/reportsicon.png';
import { Eye, EyeOff } from "lucide-react";
import rprtsactive from '../../../Assets/Component 1 (6).png';
import bnkn from '../../../Assets/bankin-icon.png';
import bnknactive from '../../../Assets/Component 1 (7).png';
import stngs from '../../../Assets/settings-icon.png';
import stngsactive from '../../../Assets/Component 1 (8).png';
import CurrencyInput from 'react-currency-input-field';
import { Dropdown, Col, Row, Button, Modal, Form, Spinner, Badge } from 'react-bootstrap';
import Select from 'react-select';
import { IoMdCloseCircleOutline } from "react-icons/io";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaBars, FaTimes } from "react-icons/fa"; 
import { CiMenuFries } from "react-icons/ci";
import { FaRegTimesCircle } from "react-icons/fa";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import JournalModal from "./Journal/Journal";
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../Components/Styles/API/API';
import RemitanceUpload from './Journal/RemittanceUpload';


const permissionToMenuMap = {
  'Manage Setup': { menu: 'Setup', path: '/accounting/loan_account' },
  'Manage Receivables': { menu: 'Receivables', paths: [
    '/accounting/customers',
    '/accounting/remitances',
    '/accounting/upload_remitance_excel',
    '/accounting/loan',
    // '/accounting/receivables/staff_loan',
    '/accounting/receivables/repayment_schedule',
    '/accounting/customers_receipts',
    '/accounting/customers_ledger',
    '/accounting/loan_ledger',
    // '/accounting/outstanding_remittance_schedule',
    // '/accounting/schedule_of_receivable'
  ]},
  'Manage Payables': { menu: 'Payables', paths: [
    '/accounting/supplier',
    // '/accounting/purchase_invoices',
    '/accounting/monthly_payable_upload',
    '/accounting/suppliers_personal_ledger',
    // '/accounting/schedule_of_payable'
  ]},
  'Manage Receipts': {menu: 'Receipts', paths: [

    '/accounting/cash_management',
    '/accounting/cash_movement' ,
    '/accounting_cashmovement',

    //   '/payment/petty_cash' ,
    // '/payment/petty_cash_bulk_entries' ,
    //   '/account_payment_voucher' ,
        '/account_payables_bulk' ,
  '/cash_management/bank_lodgement/pending' ,
  '/cash_management/lodged_transactions' ,
// '/accounting/budgets' ,
//   '/accounting/payroll' ,
  '/payment/expenses' ,
  // '/account_payables_bulk'
  ]},
  'Manage Payments': {menu: 'Payments', paths: [
   '/account_payables_bulk',
   'accounting/loan_disbursement'
  ]},
  'Manage Accountings': { menu: 'Accounting', paths: [
    '/accounting/view_journal_entries',
    '/accounting/search_account_journals',
    '/accounting/upload_opening_balance',
    '/accounting/upload_opening_balance_bulk',
    '/accounting/upload_journal_entry',
    '/accounting/national/upload_journal_entry',
    '/accounting/charts_of_account/account',
    '/accounting/account_approvals',
    '/accounting/account_dispproved'
  ]},
  'Manage Reports': { menu: 'Reports', paths: [
    'accounting/report'
    // '/accounting/cashbook',
    // '/accounting/trial_balance',
    // '/accounting/income_statement_summary',
    // '/accounting/income_statement_detailed',
    // '/accounting/activity_report_acct',
    // '/accounting/aged_analysis_payables',
    // '/accounting/aged_analysis_receivables',
    // '/financial_position',
    // '/accounting/statement_of_financial_position_admin',
    // '/accounting/bank_report',
    // '/accounting/sales_report',
    // '/accounting/purchase_report'
  ]},
};

const initialState = () => {
  const amountToPay = '';
  return [{ items: '', itemIds: '', amountToPay}];
};

export default function HeaderNav() {
  const location = useLocation();
   const [teller, setTeller] = useState("")
     const [tellerNumber, setTellerNumber] = useState("")
  const [ user, setUser ] = useState('');
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showProfile, setShowProfile] = useState(false);

  const [formData, setFormData] = useState(initialState);
  const [selectedDate, setSelectedDate] = useState('');
  const userDropdownRef = useRef(null);
    const [totalAmountToPay, setTotalAmountToPay] = useState(0);
const [showRemittanceExcelModal, setShowRemittanceExcelModal] = useState(false);
  const [showRemittanceModal, setShowRemittanceModal] = useState(false);
const [excelFile, setExcelFile] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const navigate = useNavigate();
  const [showCurrent, setShowCurrent] = useState(false);
const [showNew, setShowNew] = useState(false);
const [showConfirm, setShowConfirm] = useState(false);
    const [roless, setRoless] = useState([]);
  const [monthLoading, setMonthLoading] = useState(false);
  const [show, setShow] = useState(false);
   const [amountsToBePaid, setAmountsToBePaid] = useState({});
  const [show1, setShow1] = useState(false);
   const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [show2648, setShow2648] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [createLoading, setCreateLoading] = useState(false);
  const [createLoading1, setCreateLoading1] = useState(false);
  const [bearer, setBearer] = useState('');
  const [company, setCompany] = useState('');
  const [userType, setUserType] = useState('');
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState('');
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [selectedDated, setSelectedDated] = useState('');
   const [orgName, setOrgName] = useState("");
  const [supportEmail, setSupportEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [industry, setIndustry] = useState("");
  const [taxId, setTaxId] = useState("");
  const [currency, setCurrency] = useState("₦ NGN - Nigeria");
  const [timezone, setTimezone] = useState("Baker Island Time");
  const [chequeSize, setChequeSize] = useState("");  // NEW FIELD
  const [notes, setNotes] = useState("");

     const handleDateChangedd = (event) => {
    setSelectedDated(event.target.value);
  };
  const [selectedBank, setSelectedBank] = useState(null)
  const [interest, setInterest] = useState(0.00);
  const [totalAmount, setTotalAmount] = useState(0);
const [transactionDate, setTransactionDate] = useState("");
      const [totalRepayment, setTotalRepayment] = useState(0.00);
      const [monthlyDeduction, setMonthlyDeduction] = useState('');
      const [duration, setDuration] = useState('');
  const [province, setProvince] = useState('');
  const [validity, setValidity] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [permits, setPermits] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [provinceName, setProvinceName] = useState('');
  const [admin, setAdmin] = useState('');
  const [description, setDescription] = useState("");
  const [outstanding, setOutstanding] = useState("");
  const [currMonth, setCurrMonth] = useState('');
  const [loading, setLoading] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
   const [selectOptions, setSelectOptions] = useState([]);
       const [loans, setLoans] = useState([]);
    const [openJournalModal, setOpenJournalModal] = useState(false);
    const [currLoading, setCurrLoading] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [provinceID, setProvinceID] = useState('');
    const [defaultCur, setDefaultCur] = useState('');
     const [showPay, setShowPay] = useState(false);
const handleClosePay = () => {
  setShowPay(false);
};
 const [selectedPayment, setSelectedPayment] = useState('');
  const [journalReference, setJournalReference] = useState('');
  const toggleNav = () => setNavOpen(!navOpen);
  const handleCustomerChange = (selectedOption) => {
        setSelectedCustomer(selectedOption.value);
        setOutstanding(selectedOption.balance);
      };
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value9 = await localStorage.getItem('userEmail');
      const phoneNumber = await localStorage.getItem('phone');
      const value2 = await localStorage.getItem('allPermissions');
      const value3 = await localStorage.getItem('admin');
      const value7 = await localStorage.getItem('companyName');
      const provinceid = await localStorage.getItem('provinceID');
      const value8 = await localStorage.getItem('validity');
      const curr = await localStorage.getItem('currentMonth');
      const currencies = await localStorage.getItem('Currency');
      const province = await localStorage.getItem('province');
      const permitsss = await localStorage.getItem('modules');

      if (value !== null && value.trim() !== '') {
        setBearer(value);
      } else {
        navigate('/login');
        return;
      }
      if (value2 !== null) {
          // const parsedPermitions = JSON.parse(value2);
          // const permitionNames = parsedPermitions.map((permit) => permit.name);
          setPermissions(value2);
          console.log(value2);
        }
      if (permitsss !== null) {
        const parsedPermits = JSON.parse(permitsss);
        const permitNames = parsedPermits.map((permit) => permit.name);
        setPermits(permitNames);
        console.log('Parsed Permissions:', parsedPermits);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value9 !== null) {
        setUserEmail(value9);
      }
      if (phoneNumber !== null) {
        setUserPhone(phoneNumber);
      }
      if (currencies !== null) {
        setDefaultCur(currencies);
      }
      if (province !== null) {
        setProvinceName(province);
      }
      if (provinceid !== null) {
        setProvinceID(provinceid);
      }
      if (value8 !== null) {
        setValidity(value8);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }
      if (value7 !== null) {
        setCompany(value7);
      }
      if (curr !== null) {
        console.log(curr);
        const date = new Date(curr);
      
        setCurrMonth(date);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      
        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const storeChequeSize = (value) => {
    localStorage.setItem('chequeSize', value);
  };


  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${bearer}`,
  };

  const [rows, setRows] = useState([
  {
    beneficiaryId: "",
    outstandingAmount: "",
    accountId: "",
    amountToPay: "",
    accountOptions: [],   // <-- added
  },
]);
const [showDocModal, setShowDocModal] = useState(false);
const [currentDocUrl, setCurrentDocUrl] = useState(null);

const handleOpenDoc = (docUrl) => {
  setCurrentDocUrl(docUrl);
  setShowDocModal(true);
};

const handleCloseDoc = () => {
  setCurrentDocUrl(null);
  setShowDocModal(false);
};
const [beneficiaryData, setBeneficiaryData] = useState([]);
const [loadingRef, setLoadingRef] = useState(false);

const fetchPayables = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/fetch_beneficiary_payables`, 
      {
                         headers: {
                           'Content-Type': 'application/json',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
    );
    setBeneficiaryData(response.data?.data || []);
  } catch (err) {
    console.error(err);
  }
};

 const fetchReference = async () => {
      setLoadingRef(true);
      try {
        const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${bearer}`,
            Accept: "application/json",
          },
        });
       setJournalReference(res.data.data);
      } catch (error) {
        console.error("Error fetching journal reference:", error);
      } finally {
        setLoadingRef(false);
      }
    };

useEffect(() => {
  if (bearer)
  fetchPayables();
  fetchReference();
}, [bearer]);



const beneficiaryOptions = beneficiaryData.map(item => ({
  label: `${item.invoice_number} - ${item.supplier?.name}`,
  value: item.id,
  supplierName: item.supplier?.name,
  image: item?.attached_document
}));

// Fetch accounts function (similar to your fetchCharts)
// const fetchAccounts = async (beneficiaryId, rowIndex) => {
//   try {
//     const response = await axios.get(
//       `${BASE_URL}/fetch_beneficiary_payables`,
//       { headers }
//     );

//     const results = response.data?.data || [];

//     // Extract outstanding amount (assuming API returns it here)
//     const outstanding = results[0]?.outstanding_amount || 0;

//     // Build account options
//     const options = results.map(item => ({
//       label: `${item.gl_code} - ${item.gl_name}`,
//       value: item.id,
//     }));

//     // Update that specific row
//     const updated = [...rows];
//     updated[rowIndex].outstandingAmount = outstanding;
//     updated[rowIndex].accountOptions = options;
//     setRows(updated);

//   } catch (error) {
//     console.error("Error fetching:", error.response?.data?.message);
//   }
// };


// Handlers for row changes
const handleBeneficiaryChange = (index, selectedOption) => {
  const updated = [...rows];

  updated[index].beneficiaryId = selectedOption?.value || "";
  updated[index].supplierName = selectedOption?.supplierName || "";   // ⭐ NEW: store supplier name

  if (selectedOption) {
    // find the beneficiary entry in API data
    const beneficiary = beneficiaryData.find(
      b => b.id === selectedOption.value
    );

    updated[index].outstandingAmount = beneficiary?.balance || 0;

    // Map account options
    updated[index].accountOptions =
      beneficiary?.supplier?.banks?.map(acc => ({
        label: `${acc.bank_name} - ${acc.bank_account}`,
        value: acc.id,
        accountName: acc.account_name,
        bankName: acc.bank_name,
        accountNo: acc.bank_account,
      })) || [];
updated[index].documentUrl = beneficiary?.attached_document || null;
  } else {
    updated[index].outstandingAmount = "";
    updated[index].accountOptions = [];
    updated[index].supplierName = "";   // clear supplier name
    updated[index].documentUrl = "";   // clear supplier name
  }

  setRows(updated);
};





const handleAccountChange = (index, selectedOption) => {
  const updatedRows = [...rows];
  updatedRows[index].accountId = selectedOption?.value || "";
  setRows(updatedRows);
};

const handleAmountChanges = (index, value) => {
  const updatedRows = [...rows];
  updatedRows[index].amountToPay = value || "";
  setRows(updatedRows);
  
  // Recalculate total amount
  const total = updatedRows.reduce((sum, row) => {
    const amount = parseFloat(row.amountToPay) || 0;
    return sum + amount;
  }, 0);
  setTotalAmount(total);
};

const handleBankChanges = (selectedOption) => {
  setSelectedBank(selectedOption);
};

const addLine = () => {
  setRows([
    ...rows,
    { 
      beneficiaryId: "", 
      outstandingAmount: "", 
      accountId: "", 
      amountToPay: "" ,
       accountOptions: [],
    }
  ]);
};

const removeRow = (index) => {
  if (rows.length > 1) {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    
    // Recalculate total
    const total = updatedRows.reduce((sum, row) => {
      const amount = parseFloat(row.amountToPay) || 0;
      return sum + amount;
    }, 0);
    setTotalAmount(total);
  }
};



const [isSaving, setIsSaving] = useState(false);


  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
    const handlePaymentModeChange = (event) => {
        setSelectedPaymentMode(event.target.value);
    };
const [paymentMethod, setPaymentMethod] = useState([]);

      const fetchPaymentMethod = async () => {
            setLoading(true);
    
    
            try {
                const response = await axios.get(`${BASE_URL}/income/get-payment-method`,
                    {
    
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${bearer}`
                        }
                    }
                );
                const resultss = response.data?.data;
                setPaymentMethod(resultss);
    
                  console.log(resultss, "PaymentModes");
            } catch (error) {
                const errorStatus = error.response.data.message;
                console.error(errorStatus);
            } finally {
                setLoading(false);
            }
        };

        const [incomeAmount, setIncomeAmount] = useState();
          const handleValueChanges = (value) => {
        setIncomeAmount(value);
    };
const [newData, setNewData] = useState([]);
     const [selectedInvoice, setSelectedInvoice] = useState('');
      const [amount, setAmount] = useState('');
      const [selectedInv, setSelectedInv] = useState([]);
      const [amountToPay, setAmountToPay] = useState('');
      const [footerNotes, setFooterNotes] = useState('');

     const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice`, { headers });
      const roleList = response.data?.data;
      setNewData(roleList);
      // console.log(roleList);
      const roled = roleList.map((item) => ({
        label: `${item.invoice_number} - ${item.customer?.name}`,
        value: item.id,
      }));

      setRoless(roled);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setNewData([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

   useEffect(() => {
    if (bearer) {
      // fetchAcctName();
      // fetchItems();
      fetchData1();
      // fetchData4();
      // fetchData3();
      // fetchDebit2();
      // fetchDebit1();
    }
  }, [bearer]);

    const handleAmountChange = (value, id) => {
    setAmountsToBePaid(prevState => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSalesChange = (selectedOption) => {
    const selectedId = selectedOption.value;

    setSelectedInvoice(selectedOption.value);

    const intselectedId = parseInt(selectedId);
    const selectedInvoice = newData.find(item => item.id == intselectedId);
    setDescription(selectedInvoice?.description || '');
    setAmount(selectedInvoice?.amount || '');
    setOutstanding(selectedInvoice?.balance || '');
    setSelectedInv(Array.isArray(selectedInvoice?.items) ? selectedInvoice?.items : [selectedInvoice?.items]);
    console.log(selectedInvoice?.items);

    setAmountToPay('');

    // setAmount('');

  };

  const navItems = [
    { label: 'Dashboard', path: '/accounting', icon: iconinactive, activeIcon: icon },
    { label: 'Setup', path: '/accounting/loan_account', icon: stngs, activeIcon: stngsactive },
    { label: 'Receivables', path: '/accounting/customers', icon: trsanstin, activeIcon: trsanstinactive },
    { label: 'Payables', path: '/accounting/supplier', icon: acctn, activeIcon: acctnactive },
    { label: 'Receipts', path: '/accounting/cash_management', icon: bnkn, activeIcon: bnknactive },
    { label: 'Payments', path: '/accounting/suppliers_receipt', icon: bnkn, activeIcon: bnknactive },
    { label: 'Accounting', path: '/accounting/view_journal_entries', icon: acctn, activeIcon: acctnactive },
    { label: 'Reports', path: '/accounting/report', icon: rprts, activeIcon: rprtsactive },
  ];

   const handleOpenPayModal = () => {
  setShowPay(true);
  // Reset form when opening
  setSelectedPayment("");
  setTransactionDate("");
  setSelectedBank(null);
  setRows([{ beneficiaryId: "", outstandingAmount: "", accountId: "", amountToPay: "" }]);
  setTotalAmount(0);
  
  // Fetch fresh data if needed
  fetchCharts();
  fetchPayables();
  // fetchAccounts();
};

  const dropdownMenus = {
    Setup: [
      { label: 'Manage Loan Account', path: '/accounting/loan_account', permission: 'Manage Setup' },
    ],
    Receivables: [
      { label: 'Manage Customers', path: '/accounting/customers', permission: 'Manage Receivables' },
      { label: 'Monthly Remitances', path: '/accounting/remitances', permission: 'Manage Receivables' },
      // { label: 'Monthly Remitance Upload - Excel', path: '/accounting/upload_remitance_excel', permission: 'Manage Receivables' },
      { label: 'Monthly Remitance Upload - Excel', customAction: () => setOpenJournalModal(true), permission: 'Manage Receivables' },
      { label: 'Loan Beneficiaries', path: '/accounting/loan', permission: 'Manage Receivables' },
      { label: 'Cash Advance Recipient', path: '/accounting/cash_advances', permission: 'Manage Receivables' },
      { label: 'Loan and Advances', path: '/accounting/receivables/staff_loan', permission: 'Manage Receivables' },
      { label: 'Loan Repayment Schedule', path: '/accounting/receivables/repayment_schedule', permission: 'Manage Receivables' },
      // { label: "Customers' Receipt", path: '/accounting/customers_receipts', permission: 'Manage Receivables' },
      { label: "Customers' Personal Ledger", path: '/accounting/customers_ledger', permission: 'Manage Receivables' },
      // { label: "Staff Personal Ledger", path: '/accounting/staff_personal_ledger', permission: 'Manage Receivables' },
      { label: "Loan Ledger", path: '/accounting/loan_ledger', permission: 'Manage Receivables' },
      // { label: "Outstanding Remittance Schedule", path: '/accounting/outstanding_remittance_schedule', permission: 'Manage Receivables' },
      // { label: 'Schedule of Receivables', path: '/accounting/schedule_of_receivable', permission: 'Manage Receivables' },
    ],
    Payables: [
      { label: 'Manage Suppliers/Beneficiary', path: '/accounting/supplier', permission: 'Manage Payables' },
      { label: 'Manage PAYE', path: '/accounting/paye', permission: 'Manage Payables' },
      { label: 'Manage HMO', path: '/accounting/hmo', permission: 'Manage Payables' },
      { label: 'Manage Pension', path: '/accounting/pension', permission: 'Manage Payables' },
      { label: 'PAYE/HMO/PFA Invoices', path: '/accounting/paye_invoices', permission: 'Manage Payables' },
      { label: 'Contractors/Suppliers Invoices', path: '/accounting/contractor_invoices', permission: 'Manage Payables' },
      // { label: 'Payable Invoices', path: '/accounting/purchase_invoices', permission: 'Manage Payables' },
      // { label: 'Upload Payables', isUploadPayableModal: true, permission: 'Manage Payables' },
      { label: "Payable Entries", path: '/accounting/payable_entries', permission: 'Manage Payables' },
      { label: "Payable Approval", path: '/account_payables_payment', permission: 'Manage Payables' },
      { label: "Salary Payable Entries", path: '/accounting/salary_payables_entries', permission: 'Manage Payables' },
      { label: "Suppliers' Personal Ledger", path: '/accounting/suppliers_ledger', permission: 'Manage Payables' },
      // { label: 'Schedule of Payables', path: '/accounting/schedule_of_payable', permission: 'Manage Payables' },
    ],
    Receipts: [

    // { 
    //   label: 'Receipts',
    //   permission: 'Manage Receipts',
      // children: [
        
      // ]
    // },
    { label: 'Receipt Entries', path: '/accounting/cash_receipt', permission: 'Manage Receipts'  },
        { label: 'Province Remittance  Receipt', isRemittanceModal: true, permission: 'Manage Receipts'  },
        { label: 'Remittances - Excel Upload', isUploadRemittanceExcel: true,   permission: 'Manage Receipts'  },
    // { label: 'Bank Lodgements', path: '/accounting/bank_lodgements', permission: 'Manage Receipts' },
    // { label: 'Collection Report', path: '/accounting/collection_report', permission: 'Manage Receipts' },
    { label: 'Cash Movement', path: '/accounting_cashmovement', permission: 'Manage Receipts' },
  
 
// { label: 'Cash Movement', path: '/accounting/cash_movement', permission: 'Manage Receipts' },
  // { 
  //     label: 'Cash Movement',
  //     permission: 'Manage Receipts',
  //     children: [
  //       { label: 'Cash Receipts', path: '/cash_receipt', permission: 'Manage Receipts'  },
  //     ]
  //   },
// { label: 'Petty Cash', path: '/payment/petty_cash', permission: 'Manage Receipts' },
// { label: 'Petty Cash - Bulk Entries', path: '/payment/petty_cash_bulk_entries', permission: 'Manage Receipts' },
// { label: 'Payment Voucher', path: '/account_payment_voucher', permission: 'Manage Receipts' },
// { label: 'Payments', path: '/payment/expenses', permission: 'Manage Receipts' },
// { label: 'Payment-Bulk Entries', path: '/account_payables_bulk', permission: 'Manage Receipts' },
{ label: 'Bank Lodgement', path: '/cash_management/bank_lodgement/pending', permission: 'Manage Receipts' },
{ label: 'Lodged Transactions', path: '/cash_management/lodged_transactions', permission: 'Manage Receipts' },
// { label: 'Budgets', path: '/accounting/budgets', permission: 'Manage Receipts' },
// { label: 'Payroll', path: '/accounting/payroll', permission: 'Manage Receipts' },
],
Payments: [
  // { label: "New Payments", path: '/account_new_payments', permission: 'Manage Payables' },
  // { label: "Payables", path: '/account_payables_bulk', permission: 'Manage Payables' },
  // { label: "Payable Payments", path: '/account_payables_payment', permission: 'Manage Payables' },
  // { label: "Loan Disbursement", path: '/account_loan_disbursement', permission: 'Manage Payables' },
  { label: "Payments", path: '/account_payments', permission: 'Manage Payments' },
  { label: "Payments - From Payables", permission: 'Manage Payments', customAction: () => handleOpenPayModal() },
  { label: "Payments - Bulk Entries",  path: '/bulk_payment_entries', permission: 'Manage Payments'},
  // { label: "Payments Upload", path: '/account_payments_upload', permission: 'Manage Payables' },
  { label: "Pending Payments", path: '/account_approved_payables', permission: 'Manage Payables' },
  { label: "Cheque Payments", path: '/cheque_payments', permission: 'Manage Payables' },
  { label: "Payment Instructions", path: '/payment_instructions', permission: 'Manage Payables' },
  
// { label: "Petty Cash", permission: 'Manage Payments' },
// { label: 'Loan Disbursement', isModal: true, permission: 'Manage Payments' },
],
    Accounting: [
  { label: 'Journal Entries', path: '/accounting/view_journal_entries', permission: 'Manage Journal Entries' },
  { label: 'Search Account Journal', path: '/accounting/search_account_journals', permission: 'Search Account Journal' },
  { label: 'Upload Opening Balance - Excel', path: '/accounting/upload_opening_balance', permission: 'Upload Opening Balance (Excel)' },
  { label: 'Upload Opening Balance - Bulk', path: '/accounting/upload_opening_balance_bulk', permission: 'Upload Opening Balance (Bulk)' },
  // { label: 'Upload Journal Entry', path: '/accounting/upload_journal_entry', permission: 'Upload Journal Entry' },
  // { label: 'Upload National Journal Entry', path: '/accounting/national/upload_journal_entry', permission: 'Upload National Journal Entries' }, // 👈 requires this exact permission
  { label: 'Charts of Account', path: '/accounting/charts_of_account/account', permission: 'Manage Charts of Account' },
  { label: 'Pending Account Approvals', path: '/accounting/account_approvals', permission: 'Manage Pending Account Approvals' },
  { label: 'Disapproved Account', path: '/accounting/account_dispproved', permission: 'Manage Disapproved Accounts' },
],

    // Reports: [
    //   { label: 'Cashbook', path: '/accounting/cashbook', permission: 'Manage Reports' },
    //   { label: 'Trial Balance', path: '/accounting/trial_balance', permission: 'Manage Reports' },
    //   { label: 'Income Statement - Summary', path: '/accounting/income_statement_summary', permission: 'Manage Reports' },
    //   { label: 'Income Statement - Detailed', path: '/accounting/income_statement_detailed', permission: 'Manage Reports' },
    //   { label: 'Account Activity Report', path: '/accounting/activity_report_acct', permission: 'Manage Reports' },
    //   { label: 'Age Analysis - Payables', path: '/accounting/aged_analysis_payables', permission: 'Manage Reports' },
    //   { label: 'Age Analysis - Receivables', path: '/accounting/aged_analysis_receivables', permission: 'Manage Reports' },
    //   { label: 'Statement of Financial Position - Summary', path: '/financial_position', permission: 'Manage Reports' },
    //   { label: 'Statement of Financial Position - Detailed', path: '/accounting/statement_of_financial_position_admin', permission: 'Manage Reports' },
    //   { label: 'Bank Position Summary', path: '/accounting/bank_report', permission: 'Manage Reports' },
    //   { label: 'Sales Report', path: '/accounting/sales_report', permission: 'Manage Reports' },
    //   { label: 'Purchases Report', path: '/accounting/purchase_report', permission: 'Manage Reports' },
    // ],
  };

  // Filter navItems based on permissions
  const filteredNavItems = navItems.filter((item) => {
    if (item.label === 'Dashboard') return true; // Dashboard is always visible
    const menuPermissions = Object.keys(permissionToMenuMap).filter((perm) => permissionToMenuMap[perm].menu === item.label);
    return menuPermissions.some((perm) => permissions.includes(perm));
  });

  useEffect(() => {
    const handleClickOutside = (e) => {
      const dropdownContainer = document.querySelector(`.${classes.dropdown}`);
      if (dropdownContainer && !dropdownContainer.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  //  const handleLogout = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `${BASE_URL}/logout`,
  //       {},
  //       { headers }
  //     );
  //     navigate('/login');
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data && error.response.data.message) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Failed',
  //       text: errorMessage,
  //     });
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleLogout = () => {
    navigate('/login');
  };

  
 

  const changePassword122 = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/change_password`,
        {
          current_password: currentPassword,
          new_password: password,
          password_confirmation: passwordConfirmation,
        },
        { headers }
      );
      setCurrentPassword('');
      setPassword('');
      setPasswordConfirmation('');
      setShow(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setCreateLoading(false);
    }
  };

  const getNextMonthName = (currMonth) => {
      // Parse the currMonth string to create a Date object
      const date = new Date(currMonth);
  
      // Extract the current month (0-based index, so adding 1 to get the next month)
      let nextMonth = date.getMonth() + 1; // getMonth() is 0-based (Jan = 0)
  
      // If the next month is December (11) and we need to roll over to January
      if (nextMonth > 11) {
        nextMonth = 0;
      }
  
      // Create a new date object for the next month (day set to 1 for simplicity)
      const nextMonthDate = new Date(date.getFullYear(), nextMonth, 1);
  
      // Use toLocaleString() to get the month name in words
      const nextMonthName = nextMonthDate.toLocaleString("default", {
        month: "long",
      });
  
      return nextMonthName;
    };
  
    const getPrevMonthName = (currMonth) => {
      // Parse the currMonth string to create a Date object
      const date = new Date(currMonth);
  
      // Extract the current month and subtract 1 to get the previous month
      let prevMonth = date.getMonth() - 1; // getMonth() is 0-based (Jan = 0)
  
      // If the previous month is before January, roll over to December of the previous year
      if (prevMonth < 0) {
        prevMonth = 11; // December
        date.setFullYear(date.getFullYear() - 1); // Move to the previous year
      }
  
      // Create a new date object for the previous month (day set to 1 for simplicity)
      const prevMonthDate = new Date(date.getFullYear(), prevMonth, 1);
  
      // Use toLocaleString() to get the month name in words
      const prevMonthName = prevMonthDate.toLocaleString("default", {
        month: "long",
      });
  
      return prevMonthName;
    };
  
    const getCurrentMonthName = (currMonth) => {
      // Parse the currMonth string to create a Date object
      const date = new Date(currMonth);
  
      // Use toLocaleString() to get the current month name in words
      const currentMonthName = date.toLocaleString("default", { month: "long" });
  
      return currentMonthName;
    };

      
            useEffect(() => {
              if (bearer) {
                  fetchPaymentMethod();
           
              }
          }, [bearer]);

      const [isLoading, setIsLoading] = useState(false);
       const [loanInterest, setLoanInterest] = useState(0.00);
       const [cus, setCus] = useState([]);

          const fetchSupplierss = async () => {
            setIsLoading(true);
            try {
              const response = await axios.get(`${BASE_URL}/customer/loan-customers`, { headers });
              console.log(response)
              // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
              const results = response.data?.data?.data;
              console.log("results:", results)
              const options = results.map((item) => ({
                label: item.name,
                value: item.id,
              }));
              setCustomers(results);
              setSelectOptions(options);
            } catch (error) {
              const errorStatus = error.response?.data?.message;
              console.log(errorStatus);
              setCustomers([]);
            } finally {
              setIsLoading(false);
            }
          };

          const fetchCustomers = async () => {
            setIsLoading(true);
            try {
              const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
              console.log(response)
              // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
              const results = response.data?.data;
              console.log("results:", results)
              const options = results.map((item) => ({
                label: item.name,
                value: item.id,
                balance: item.balance
              }));
              setCus(options);
            } catch (error) {
              const errorStatus = error.response?.data?.message;
              console.log(errorStatus);
              setCus([]);
            } finally {
              setIsLoading(false);
            }
          };
    
           const fetchLoans = async () => {
              setIsLoading(true);
              try {
                const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
                const results = response.data?.data;
          
                const options1 = results.map((item) => ({
                  label: item.description,
                  value: item.id,
                  interest: item.interest
                }));
                setLoans(options1);
                // setSelectOptions(options);
              } catch (error) {
                const errorStatus = error.response?.data?.message;
                console.log(errorStatus);
                setLoans([]);
              } finally {
                setIsLoading(false);
              }
            };
    
             useEffect(() => {
            if (bearer) {
              fetchSupplierss();
              fetchLoans();
              fetchCustomers();
            }
          }, [bearer]);
    
          const [selectedLoan, setSelectedLoan] = useState(null);
          
    
    
           const handleLoanTypeChange = (selectedOption) => {
        setSelectedLoan(selectedOption.value);
        const selectedLoanInterest = selectedOption.interest;
        setLoanInterest(selectedLoanInterest === null ? "0.00" : selectedLoanInterest);
      };

  const handleTrashClick1 = async () => {
      const currentMonthName = getCurrentMonthName(currMonth);
      const nextMonthName = getNextMonthName(currMonth);
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to change your working month from ${currentMonthName} to ${nextMonthName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Change it!",
        cancelButtonText: "No, Cancel",
      });
  
      if (!confirmed.isConfirmed) {
        return; // User canceled, do nothing
      }
  
      // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
      Swal.fire({
        title: "Changing the working month...",
        text: "Please wait while we process your request.",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false, // Hide the confirm button
        didOpen: () => {
          Swal.showLoading(); // Show loading spinner
        },
      });
  
      setMonthLoading(true);
  
      try {
        const response = await axios.post(
          `${BASE_URL}/provinces/update-province-month`,
          {}, // Empty body
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${bearer}`,
            },
          }
        );
  
        // Close the loading Swal and show the success message
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
        navigate("/login");
      } catch (error) {
        let errorMessage = "An error occurred. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
  
        // Close the loading Swal and show the error message
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
        console.log(error);
      } finally {
        setMonthLoading(false); // Stop loading
      }
    };
  
    const handleTrashClick2 = async () => {
      const currentMonthName = getCurrentMonthName(currMonth);
      const prevMonthName = getPrevMonthName(currMonth);
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to reset your working month from ${currentMonthName} to ${prevMonthName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Reset it!",
        cancelButtonText: "No, Cancel",
      });
  
      if (!confirmed.isConfirmed) {
        return; // User canceled, do nothing
      }
  
      // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
      Swal.fire({
        title: "Resetting the working month...",
        text: "Please wait while we process your request.",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false, // Hide the confirm button
        didOpen: () => {
          Swal.showLoading(); // Show loading spinner
        },
      });
  
      setMonthLoading(true);
  
      try {
        const response = await axios.post(
          `${BASE_URL}/provinces/reverse-province-month`,
          {}, // Empty body
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${bearer}`,
            },
          }
        );
  
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
        navigate("/login");
        //   setTrashClicked1(true);
      } catch (error) {
        let errorMessage = "An error occurred. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
        console.log(error);
      } finally {
        setMonthLoading(false); // Stop loading
      }
    };

  const getInitials = (name) => {
    const parts = name?.trim().split(' ');
    const firstTwo = parts?.slice(0, 2);
    return firstTwo.map((part) => part.charAt(0).toUpperCase()).join('');
  };

  const initials = getInitials(user);

    const [showLoanModal, setShowLoanModal] = useState(false);
       const handleClose = () => {
    setShowLoanModal(false);
  };

  const [showCustomer, setShowCustomer] = useState(false);
        const handleCloseCustomer = () => setShowCustomer(false);
        const handleShowCustomer = () => {
           setShowCustomer(true);
           handleClose();
        }
        const [selectedImage, setSelectedImage] = useState('');
  
    const createLoans = async () => {
      setLoading(true);
  
      try {
  
        const formData = new FormData();
        formData.append('doc', selectedImage);
        // formData.append("bank", selectedBank);
        formData.append("loan_name", selectedLoan);
  
  
        const response = await axios.post(
          `${BASE_URL}/account/upload-staff-loan-payment`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
  
        console.log(response, "heeee");
        // setBalances(response.data.data);
        handleCloseCustomer();
        // Reset form fields
        setSelectedImage("");
        Swal.fire({
          icon: 'success',
          title: 'Successful',
          text: response.data.message,
        }).then(() => {
          window.location.reload();
        });
        // toast.success(response.data.message);
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
          });
        }
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
  
     const handleImageChange = (event) => {
      const file = event.target.files[0];
      setSelectedImage(file);
    };

    const [selectedDatess, setSelectedDatess] = useState('');
      const handleDateChangess = (event) => {
        setSelectedDatess(event.target.value);
      };
    
        const handleSupplierChange = (selectedOption) => {
        setSelectedCustomer(selectedOption.value);
      }

       const [principalAmount, setPrincipalAmount] = useState(''); 
        
          const handleValueChange = (value, name, values) => {
          setPrincipalAmount(value);
        };
      
        const handleValueChange1 = (value, name, values) => {
          setLoanInterest(value);
        };
      
        const handleValueChange2 = (value, name, values) => {
          setInterest(value);
        };

        const [banks, setBanks] = useState([]);
         const [selectedBanks, setSelectedBanks] = useState(null)

          const handleBankChange = (selectedOption) => {
             setSelectedBanks(selectedOption);
           }

          
        const fetchBanks = async () => {
  setIsLoading(true);

  // decide endpoint
  const endpoint =
    selectedPayment?.toLowerCase() === "cash"
      ? "/account/cash"
      : "/account/bank-accounts";

  try {
    const response = await axios.get(`${BASE_URL}${endpoint}`, { headers });
    const results = response.data?.data || [];

    const options = results.map(item => ({
      label: item.gl_name,
      value: item.id,
    }));

    setBanks(options);
  } catch (error) {
    console.log(error.response?.data?.message);
    setBanks([]);
  } finally {
    setIsLoading(false);
  }
};


          useEffect(() => {
  if (selectedPayment) {
    fetchBanks();
  }
}, [selectedPayment]);

              const handlePaymentChange = (selectedOption) => {
             if (selectedOption) {
                 const selectedValue = selectedOption.value; // Access the value here
                 console.log('Selected value:', selectedValue); // For debugging
                 // Set the selected payment mode or perform any other action you need
                 // setSelectedPaymentMode(selectedValue); // Assuming you're updating the payment mode
           
                 setSelectedBanks(selectedValue);
           
             } else {
                 console.error('Selected option is undefined');
             }
           };
         
      
        const handleValueChange3 = (value, name, values) => {
          setTotalRepayment(value);
        };
      
        const handleValueChange4 = (value, name, values) => {
          setMonthlyDeduction(value);
        };
      
        
          useEffect(() => {
            const calculateInterestRate = () => {
              const calculatedInterestRate = (parseFloat(loanInterest) / 100) * parseFloat(principalAmount);
              const formattedInterestRate = isNaN(calculatedInterestRate) ? "0.00" : calculatedInterestRate.toFixed(2);
        
              setInterest(formattedInterestRate);
            };
        
            calculateInterestRate();
          }, [loanInterest, principalAmount]);
        
        
          useEffect(() => {
            const calculateTotalRepayment = () => {
              const calculatedTotalRepayment = parseFloat(principalAmount) + parseFloat(interest);
              const formattedTotalRepayment = isNaN(calculatedTotalRepayment) ? "0.00" : calculatedTotalRepayment.toFixed(2);
        
              setTotalRepayment(formattedTotalRepayment);
            };
        
            calculateTotalRepayment();
          }, [interest, principalAmount]);
        
          useEffect(() => {
            const calculateReturn = () => {
              const calculatedReturn = parseFloat(totalRepayment) / parseFloat(duration);
              const formattedReturn = isNaN(calculatedReturn) ? "0.00" : calculatedReturn.toFixed(2);
        
              setMonthlyDeduction(formattedReturn);
            };
        
            calculateReturn();
          }, [totalRepayment, duration]);

useEffect(() => {
    const initialAmounts = selectedInv.reduce((acc, row) => {
    
      if (acc[row.id] === undefined) {
        acc[row.id] = row.balance;
      }
      return acc;
    }, {});
  
    setAmountsToBePaid(initialAmounts);
  }, [selectedInv]);
            
          
                const createLoan = async () => {
                  setCreateLoading(true);
                  try {
                    const response = await axios.post(
                      `${BASE_URL}/account/staff-loan`,
                      {
                        member_name: selectedCustomer || '',
                        loan_name: selectedLoan || '',
                        bank: selectedBanks.value,
                        principal_amount: principalAmount,
                        interest_amount: interest,
                        total_repayment: totalRepayment,
                        monthly_deduction: monthlyDeduction,
                        loan_interest: loanInterest,
                        duration: duration,
                        transaction_date: selectedDatess,
                        // cheque_number: cheque
              
              
                      },
                      { headers }
                    );
                    console.log(response.data.message)
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: response.data.message,
                    });
              handleClose();
             
                    setSelectedCustomer(null);
                    setSelectedLoan(null);
                    setSelectedBanks(null);
                    // setSelectedDate('');
                    setSelectedDatess('');
                    setPrincipalAmount('');
                    setLoanInterest('');
                    setInterest('');
                    setTotalRepayment('');
                    // setCheque('');
                    setDuration('');
                    setMonthlyDeduction('');
              
                    // navigate('/loans_advances')
              
                    // return
                    //   Swal.fire({
                    //     icon: 'success',
                    //     title: 'Success',
                    //     text: response.data.message,
                    //   });
                    //   console.log(response.data);
              
                    // } catch (error) {
                    //   const errorStatus = error.response.data.message;
                    //   Swal.fire({
                    //     icon: 'error',
                    //     title: 'Failed',
                    //     text: errorStatus,
                    //   });
                    //   console.log(error);
              
                  } catch (error) {
                    let errorMessage = 'An error occurred. Please try again.';
                    if (error.response && error.response.data && error.response.data.message) {
                      if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                      } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                      } else if (typeof error.response.data.message === 'object') {
                        console.log(error.response.data.message);
                      }
                    }
                    Swal.fire({
                      icon: 'error',
                      title: 'Failed',
                      text: JSON.stringify(error.response.data.data),
                    });
                  } finally {
                    setCreateLoading(false);
                  }
                };

                const changeProfile = async () => {
                  setCreateLoading1(true);
                  try {
                    const response = await axios.post(
                      `${BASE_URL}/provinces/update-profile`,
                      {
                        province_id: provinceID,
                        email: userEmail,
                        phone_no: userPhone,
                        address: address,
                        timezone: timezone,
                        cheque_size: chequeSize,
                        currency_id: selectedCurrency,
                        // cheque_number: cheque
                      },
                      { headers }
                    );
                    console.log(response.data.message)
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: response.data.message,
                    });
                    setShowProfile(false)
             
                  } catch (error) {
                    let errorMessage = 'An error occurred. Please try again.';
                    if (error.response && error.response.data && error.response.data.message) {
                      if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                      } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                      } else if (typeof error.response.data.message === 'object') {
                        console.log(error.response.data.message);
                      }
                    }
                    Swal.fire({
                      icon: 'error',
                      title: 'Failed',
                      text: JSON.stringify(error.response.data.data),
                    });
                  } finally {
                    setCreateLoading1(false);
                  }
                };

                // Upload Payables modals
const [showTypeModal, setShowTypeModal] = useState(false);
const [showFormModal, setShowFormModal] = useState(false);
const [payableType, setPayableType] = useState(""); // "Salary" or "Pension"
const handleOpenUploadType = () => setShowTypeModal(true);
const handleCloseTypeModal = () => setShowTypeModal(false);

 useEffect(() => {
    // Calculate the total sum whenever amountsToBePaid changes
    const total = Object.values(amountsToBePaid).reduce((acc, value) => {
      // Ensure value is a number before adding to the total
      const numValue = parseFloat(value) || 0;
      return acc + numValue;
    }, 0);
    
    // Round the total to 2 decimal places
    const roundedTotal = parseFloat(total.toFixed(2));
    
    setTotalAmountToPay(roundedTotal);
  }, [amountsToBePaid]);

const handleSelectType = (type) => {
  setPayableType(type);
  setShowTypeModal(false);
  setShowFormModal(true);
};

const handleCloseFormModal = () => {
  setShowFormModal(false);
  setPayableType("");
};


  const [debit1, setDebit1] = useState([]);
  const [debit2, setDebit2] = useState([]);
  const [debit3, setDebit3] = useState([]);
  const [debit4, setDebit4] = useState([]);

    const fetchDebit1 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/expenses`, { headers });
  
        const debt1 = response.data?.data;
        const oopt1 = debt1.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit1(oopt1);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
    const fetchDebit3 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
  
        const debt1 = response.data?.data;
        const oopt1 = debt1.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit3(oopt1);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    const fetchDebit2 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
  
        const debt2 = response.data?.data;
        const oopt2 = debt2.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit2(oopt2);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
    const fetchDebit4 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/cash`, { headers });
  
        const debt2 = response.data?.data;
        const oopt2 = debt2.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit4(oopt2);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (bearer) {
        fetchDebit1();
        fetchDebit2();
        fetchDebit3();
        fetchDebit4();
      }
    }, [bearer]);

    const[selectedExpenses, setSelectedExpenses] = useState('')
    const[date, setDate] = useState('')
    const [selectedImagesss, setSelectedImagesss] = useState('');
      const[selectedPayable, setSelectedPayable] = useState('')
    
       const handleImageChangessss = (event) => {
    const file = event.target.files[0];
    setSelectedImagesss(file);
  };
      const handledExpenses = (selectedOption) => {
        setSelectedExpenses(selectedOption.value);
      };
      const handlePayables = (selectedOption) => {
        setSelectedPayable(selectedOption.value);
      };
             const [tableData, setTableData] = useState([]);
             const [selectedBeneficiary, setSelectedBeneficiary] = useState('');  
             
               const fetchCharts = async () => {
                 setIsLoading(true);
                 try {
                   const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
                   const results = response.data?.data;
             
                   const opt1 = results.map((item) => ({
                     label: item.name,
                     value: item.id,
                   }));
                   console.log(response);
                   setTableData(opt1);
             
                 } catch (error) {
                   const errorStatus = error.response?.data?.message;
                   console.log(errorStatus);
                   setTableData([]);
                 } finally {
                   setIsLoading(false);
                 }
               };
             
               useEffect(() => {
                 if (bearer) {
                   fetchCharts();
             
                 }
               }, [bearer]);

                 const uploadStatement = async () => {
                   setCreateLoading(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('file', selectedImagesss);
                     formData.append('payable', selectedPayable);
                     formData.append('expense', selectedExpenses);
                     formData.append('transaction_date', date);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/upload-payable-excel`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                     setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreateLoading(false);
                   }
                 };

                 const uploadRemittance = async () => {
                   setCreateLoading(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('file', excelFile);
                     formData.append('bank', selectedBanks);
                     formData.append('customer_id', selectedCustomer);
                     formData.append('transaction_date', selectedDate);
                    //  formData.append('mode', selectedPaymentMode);
                     formData.append('cheque_number', teller);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/upload_remittance_payment_new`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                     setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreateLoading(false);
                   }
                 };
const [paymentLoading, setPaymentLoading] = useState(false);
                 const [create, setCreate] = useState(false);
  const createPayment = async () => {
    setPaymentLoading(true);

    try {

      const filteredItems = selectedInv.filter(
        (item) => amountsToBePaid[item.id] && parseFloat(amountsToBePaid[item.id]) > 0
      );

      const itemIds = filteredItems.map((item) => item.id);
      const itemAmounts = filteredItems.map((item) => parseFloat(amountsToBePaid[item.id]));



      let requestData = {
        // debit_gl_code: selectedDebitAccount,
        // debit_gl_code: selectedPaymentMode,
        id: selectedInvoice,
        debit_gl_code: selectedBanks,
        transaction_date: selectedDated,
        amount: totalAmountToPay || '',
        item_id: itemIds,
        item_amount: itemAmounts,
        mode: selectedPaymentMode,
        cheque_number: teller,
      };

     
      // return;
      const response = await axios.post(
        `${BASE_URL}/pay-sales-invoice`,
        requestData,
        { headers }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

      setShowRemittanceModal(false);

      // Reset all form data
setSelectedInvoice('');
setSelectedInv([]);
setAmountsToBePaid({});
setSelectedBanks(null);
setSelectedPaymentMode('');
setSelectedDated('');
setDescription('');
setAmount('');
setOutstanding('');
setTeller('');
setTellerNumber('');
setTotalAmountToPay(0);

// Optional: clear any derived data
fetchData1();

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(errorMessage);
      }
    } finally {
      setPaymentLoading(false);
    }
  };

  
                 const createRemitance = async () => {
                   setCreate(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('bank', selectedBanks);
                     formData.append('customer_id', selectedCustomer);
                     formData.append('transaction_date', selectedDated);
                     formData.append('mode', selectedPaymentMode);
                     formData.append('cheque_number', teller);
                     formData.append('description', description);
                     formData.append('amount', incomeAmount);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/save-casual-payment`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                    //  setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                    setShowRemittanceModal(false);
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreate(false);
                   }
                 };
                 const uploadStatements = async () => {
                   setCreateLoading(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('file', selectedImagesss);
                     formData.append('payable', selectedPayable);
                     formData.append('expense', selectedExpenses);
                     formData.append('transaction_date', date);
                     formData.append('beneficiary_id', selectedBeneficiary.value);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/upload-beneficiary-payable-excel`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                     setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreateLoading(false);
                   }
                 };
   const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const fetchCurrency1 = async () => {
    setCurrLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
      const results = response.data?.data;
        // console.log(results, "currencis")
      const options = results.map((item) => ({
        label: item.code,
        value: item.id,
        currency: item.currency,
        symbol: item.symbol,
        country: item.country
      }));
      setCurrency(options);
      // setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCurrency([]);
    } finally {
        setCurrLoading(false);
    }
  };
// currency
  useEffect(() => {
    if (bearer) {
        fetchCurrency1();
    }
}, [bearer]);

// const optionsWithDefault = defaultCur
//   ? [defaultCur, ...currency.filter(c => c.value !== defaultCur.value)]
//   : currency;

  // useEffect(() => {
  //   const stored = localStorage.getItem("defaultCurrency");
  //   if (stored) {
  //     const parsed = JSON.parse(stored);
  
  //     // parsed = { label: "...", value: "...", country: "..." }
  //     setDefaultCur(parsed);
  //   }
  // }, []);

  const tempDefaultOption =
  defaultCur && typeof defaultCur === "string"
    ? { label: defaultCur, value: "__default__" }   // fake value
    : null;


const optionsWithDefault = currency;
  


const handleCurrencyChange = (selected) => {
  setSelectedCurrency(selected.value);
  
};

const timezoneList = [
  { offset: 'UTC-12:00', description: 'International Date Line West' },
  { offset: 'UTC-11:00', description: 'Coordinated Universal Time-11' },
  { offset: 'UTC-10:00', description: 'Aleutian Islands' },
  { offset: 'UTC-10:00', description: 'Hawaii' },
  { offset: 'UTC-09:30', description: 'Marquesas Islands' },
  { offset: 'UTC-09:00', description: 'Alaska' },
  { offset: 'UTC-09:00', description: 'Coordinated Universal Time-09' },
  { offset: 'UTC-08:00', description: 'Baja California' },
  { offset: 'UTC-08:00', description: 'Coordinated Universal Time-08' },
  { offset: 'UTC-08:00', description: 'Pacific Time (US & Canada)' },
  { offset: 'UTC-07:00', description: 'Arizona' },
  { offset: 'UTC-07:00', description: 'Chihuahua, La Paz, Mazatlan' },
  { offset: 'UTC-07:00', description: 'Mountain Time (US & Canada)' },
  { offset: 'UTC-06:00', description: 'Central America' },
  { offset: 'UTC-06:00', description: 'Central Time (US & Canada)' },
  { offset: 'UTC-06:00', description: 'Easter Island' },
  { offset: 'UTC-06:00', description: 'Guadalajara, Mexico City, Monterrey' },
  { offset: 'UTC-06:00', description: 'Saskatchewan' },
  { offset: 'UTC-05:00', description: 'Bogota, Lima, Quito, Rio Branco' },
  { offset: 'UTC-05:00', description: 'Chetumal' },
  { offset: 'UTC-05:00', description: 'Eastern Time (US & Canada)' },
  { offset: 'UTC-05:00', description: 'Haiti' },
  { offset: 'UTC-05:00', description: 'Havana' },
  { offset: 'UTC-05:00', description: 'Indiana (East)' },
  { offset: 'UTC-05:00', description: 'Turks and Caicos' },
  { offset: 'UTC-04:00', description: 'Asuncion' },
  { offset: 'UTC-04:00', description: 'Atlantic Time (Canada)' },
  { offset: 'UTC-04:00', description: 'Caracas' },
  { offset: 'UTC-04:00', description: 'Cuiaba' },
  { offset: 'UTC-04:00', description: 'Georgetown, La Paz, Manaus, San Juan' },
  { offset: 'UTC-04:00', description: 'Santiago' },
  { offset: 'UTC-03:30', description: 'Newfoundland' },
  { offset: 'UTC-03:00', description: 'Araguaina' },
  { offset: 'UTC-03:00', description: 'Brasilia' },
  { offset: 'UTC-03:00', description: 'Cayenne, Fortaleza' },
  { offset: 'UTC-03:00', description: 'City of Buenos Aires' },
  { offset: 'UTC-03:00', description: 'Greenland' },
  { offset: 'UTC-03:00', description: 'Montevideo' },
  { offset: 'UTC-03:00', description: 'Punta Arenas' },
  { offset: 'UTC-03:00', description: 'Saint Pierre and Miquelon' },
  { offset: 'UTC-03:00', description: 'Salvador' },
  { offset: 'UTC-02:00', description: 'Coordinated Universal Time-02' },
  { offset: 'UTC-01:00', description: 'Azores' },
  { offset: 'UTC-01:00', description: 'Cabo Verde Is.' },
  { offset: 'UTC', description: 'Coordinated Universal Time' },
  { offset: 'UTC+00:00', description: 'Dublin, Edinburgh, Lisbon, London' },
  { offset: 'UTC+00:00', description: 'Monrovia, Reykjavik' },
  { offset: 'UTC+00:00', description: 'Sao Tome' },
  { offset: 'UTC+01:00', description: 'Casablanca' },
  { offset: 'UTC+01:00', description: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' },
  { offset: 'UTC+01:00', description: 'Belgrade, Bratislava, Budapest, Ljubljana, Prague' },
  { offset: 'UTC+01:00', description: 'Brussels, Copenhagen, Madrid, Paris' },
  { offset: 'UTC+01:00', description: 'Sarajevo, Skopje, Warsaw, Zagreb' },
  { offset: 'UTC+01:00', description: 'West Central Africa' },
  { offset: 'UTC+02:00', description: 'Amman' },
  { offset: 'UTC+02:00', description: 'Athens, Bucharest' },
  { offset: 'UTC+02:00', description: 'Beirut' },
  { offset: 'UTC+02:00', description: 'Cairo' },
  { offset: 'UTC+02:00', description: 'Chisinau' },
  { offset: 'UTC+02:00', description: 'Damascus' },
  { offset: 'UTC+02:00', description: 'Gaza, Hebron' },
  { offset: 'UTC+02:00', description: 'Harare, Pretoria' },
  { offset: 'UTC+02:00', description: 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius' },
  { offset: 'UTC+02:00', description: 'Jerusalem' },
  { offset: 'UTC+02:00', description: 'Kaliningrad' },
  { offset: 'UTC+02:00', description: 'Khartoum' },
  { offset: 'UTC+02:00', description: 'Tripoli' },
  { offset: 'UTC+02:00', description: 'Windhoek' },
  { offset: 'UTC+03:00', description: 'Baghdad' },
  { offset: 'UTC+03:00', description: 'Istanbul' },
  { offset: 'UTC+03:00', description: 'Kuwait, Riyadh' },
  { offset: 'UTC+03:00', description: 'Minsk' },
  { offset: 'UTC+03:00', description: 'Moscow, St. Petersburg' },
  { offset: 'UTC+03:00', description: 'Nairobi' },
  { offset: 'UTC+03:30', description: 'Tehran' },
  { offset: 'UTC+04:00', description: 'Abu Dhabi, Muscat' },
  { offset: 'UTC+04:00', description: 'Astrakhan, Ulyanovsk' },
  { offset: 'UTC+04:00', description: 'Baku' },
  { offset: 'UTC+04:00', description: 'Izhevsk, Samara' },
  { offset: 'UTC+04:00', description: 'Port Louis' },
  { offset: 'UTC+04:00', description: 'Saratov' },
  { offset: 'UTC+04:00', description: 'Tbilisi' },
  { offset: 'UTC+04:00', description: 'Volgograd' },
  { offset: 'UTC+04:00', description: 'Yerevan' },
  { offset: 'UTC+04:30', description: 'Kabul' },
  { offset: 'UTC+05:00', description: 'Ashgabat, Tashkent' },
  { offset: 'UTC+05:00', description: 'Ekaterinburg' },
  { offset: 'UTC+05:00', description: 'Islamabad, Karachi' },
  { offset: 'UTC+05:00', description: 'Qyzylorda' },
  { offset: 'UTC+05:30', description: 'Chennai, Kolkata, Mumbai, New Delhi' },
  { offset: 'UTC+05:30', description: 'Sri Jayawardenepura' },
  { offset: 'UTC+05:45', description: 'Kathmandu' },
  { offset: 'UTC+06:00', description: 'Astana' },
  { offset: 'UTC+06:00', description: 'Dhaka' },
  { offset: 'UTC+06:00', description: 'Omsk' },
  { offset: 'UTC+06:30', description: 'Yangon (Rangoon)' },
  { offset: 'UTC+07:00', description: 'Bangkok, Hanoi, Jakarta' },
  { offset: 'UTC+07:00', description: 'Barnaul, Gorno-Altaysk' },
  { offset: 'UTC+07:00', description: 'Hovd' },
  { offset: 'UTC+07:00', description: 'Krasnoyarsk' },
  { offset: 'UTC+07:00', description: 'Novosibirsk' },
  { offset: 'UTC+07:00', description: 'Tomsk' },
  { offset: 'UTC+08:00', description: 'Beijing, Chongqing, Hong Kong, Urumqi' },
  { offset: 'UTC+08:00', description: 'Irkutsk' },
  { offset: 'UTC+08:00', description: 'Kuala Lumpur, Singapore' },
  { offset: 'UTC+08:00', description: 'Perth' },
  { offset: 'UTC+08:00', description: 'Taipei' },
  { offset: 'UTC+08:00', description: 'Ulaanbaatar' },
  { offset: 'UTC+08:45', description: 'Eucla' },
  { offset: 'UTC+09:00', description: 'Chita' },
  { offset: 'UTC+09:00', description: 'Osaka, Sapporo, Tokyo' },
  { offset: 'UTC+09:00', description: 'Pyongyang' },
  { offset: 'UTC+09:00', description: 'Seoul' },
  { offset: 'UTC+09:00', description: 'Yakutsk' },
  { offset: 'UTC+09:30', description: 'Adelaide' },
  { offset: 'UTC+09:30', description: 'Darwin' },
  { offset: 'UTC+10:00', description: 'Brisbane' },
  { offset: 'UTC+10:00', description: 'Canberra, Melbourne, Sydney' },
  { offset: 'UTC+10:00', description: 'Guam, Port Moresby' },
  { offset: 'UTC+10:00', description: 'Hobart' },
  { offset: 'UTC+10:00', description: 'Vladivostok' },
  { offset: 'UTC+10:30', description: 'Lord Howe Island' },
  { offset: 'UTC+11:00', description: 'Bougainville Island' },
  { offset: 'UTC+11:00', description: 'Chokurdakh' },
  { offset: 'UTC+11:00', description: 'Magadan' },
  { offset: 'UTC+11:00', description: 'Norfolk Island' },
  { offset: 'UTC+11:00', description: 'Sakhalin' },
  { offset: 'UTC+11:00', description: 'Solomon Is., New Caledonia' },
  { offset: 'UTC+12:00', description: 'Anadyr, Petropavlovsk-Kamchatsky' },
  { offset: 'UTC+12:00', description: 'Auckland, Wellington' },
  { offset: 'UTC+12:00', description: 'Coordinated Universal Time+12' },
  { offset: 'UTC+12:00', description: 'Fiji' },
  { offset: 'UTC+12:45', description: 'Chatham Islands' },
  { offset: 'UTC+13:00', description: 'Coordinated Universal Time+13' },
  { offset: 'UTC+13:00', description: "Nuku'alofa" },
  { offset: 'UTC+13:00', description: 'Samoa' },
  { offset: 'UTC+14:00', description: 'Kiritimati Island' }
];


   const handleDateChanged = (event) => {
    setSelectedDated(event.target.value);
  };

    const handleFetchPayments = async () => {
  setIsSaving(true);

  try {
    const payableIds = rows.map(row => row.beneficiaryId);
    const beneficiaryBankIds = rows.map(row => row.accountId);
    const amounts = rows.map(row => row.amountToPay || 0);
const supplierNames = [...new Set(rows.map(r => r.supplierName))];
    const payload = {
      transaction_date: transactionDate,
      payment_mode: selectedPayment,
      bank_id: selectedBank?.value || selectedBank,
      payable_id: payableIds,
      beneficiary_bank_id: beneficiaryBankIds,
      amount: amounts,
      receipt_number: journalReference
    };

    const response = await axios.post(
      `${BASE_URL}/process-pending-payables`,
      payload,
      { headers }
    );

    // Swal.fire({
    //   icon: "success",
    //   title: "Success",
    //   text: response.data.message,
    // });

    // ⭐ ROUTING BASED ON PAYMENT TYPE
    if (selectedPayment === "bank transfer") {
      navigate("/payable_instruction", {
        state: {
          rowsToPass: rows,
          selectedBankName: selectedBank?.label,
          selectedBankAc: selectedBank?.account,
          batchNumber: journalReference
        }
      });

    } else if (selectedPayment === "cheque") {
      navigate("/payable_cheque", {
        state: {
          rawInvoice: rows,
          supplierNames: supplierNames,
        }
      });
    }
    Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data.message,
    }).then(() => {
      window.location.reload();
    });
    handleClosePay();

    // (optional reset if page does not navigate immediately)
    // setSelectedPayment("");
    // setTransactionDate("");
    // setSelectedBank(null);

  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";

    if (error.response?.data?.message) {
      errorMessage = typeof error.response.data.message === "string"
        ? error.response.data.message
        : JSON.stringify(error.response.data.message);
    }

    Swal.fire({ icon: "error", title: "Oops...", text: errorMessage });

  } finally {
    setIsSaving(false);
  }
};


  return (
    <div className={classes.entnav22}>
      <NavLink to="/accounting">  <img src={logo} alt="Logo" className={classes.logo} /></NavLink>

      <div className={`${classes.headerNav} ${classes.desktopOnly}`}>
        {filteredNavItems.map((item) => {
    const isActive = location.pathname.startsWith(item.path);
    const hasDropdown = dropdownMenus[item.label];

    // Filter dropdown items based on permissions
    const filteredDropdownItems = hasDropdown
      ? dropdownMenus[item.label].filter((sub) => {
          if (item.label === 'Accounting') {
            // Accounting requires specific permissions for each submenu
            return permissions.includes(sub.permission);
          } else {
            // Other menus still rely on their parent-level permission
            return permissions.includes(sub.permission);
          }
        })
      : [];

    return hasDropdown && filteredDropdownItems.length > 0 ? (
      <div
        key={item.label}
        className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
      >
        <div
          className={classes.dshbrdnavMain}
          onClick={() =>
            setOpenDropdown(openDropdown === item.label ? null : item.label)
          }
        >
          <img
            src={isActive ? item.activeIcon : item.icon}
            alt={`${item.label} icon`}
            className={classes.dshbrdicon}
          />
          <p
            className={isActive ? classes.activeText : ''}
            style={{ whiteSpace: 'nowrap' }}
          >
            {item.label}
          </p>
        </div>
        {openDropdown === item.label && (
  <div className={classes.dropdown}>
  {filteredDropdownItems.map((sub, index) =>
      sub.children ? (
        // Handle nested dropdowns with children
        <div key={index} className={classes.dropdownWithSub}>
          <span className={classes.dropdownItem}>{sub.label}</span>
          <div className={classes.subDropdown}>
            {sub.children.map((child, cIndex) => {
              if (child.isUploadRemittanceExcel) {
                return (
                  <div
                    key={cIndex}
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowRemittanceExcelModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {child.label}
                  </div>
                );
              }
              if (child.isRemittanceModal) {
                return (
                  <div
                    key={cIndex}
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowRemittanceModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {child.label}
                  </div>
                );
              }
              return (
                <NavLink
                  key={cIndex}
                  to={child.path}
                  onClick={() => setOpenDropdown(null)}
                  className={({ isActive }) =>
                    `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
                  }
                >
                  {child.label}
                </NavLink>
              );
            })}
          </div>
        </div>
      ) : (
        // Handle direct menu items (including remittance modals)
        <div key={index}>
          {sub.isUploadPayableModal ? (
            <div
              className={classes.dropdownItem}
              onClick={() => {
                handleOpenUploadType();
                setOpenDropdown(null);
              }}
            >
              {sub.label}
            </div>
          ) : sub.isUploadRemittanceExcel ? (
            <div
              className={classes.dropdownItem}
              onClick={() => {
                setShowRemittanceExcelModal(true);
                setOpenDropdown(null);
              }}
            >
              {sub.label}
            </div>
          ) : sub.isRemittanceModal ? (
            <div
              className={classes.dropdownItem}
              onClick={() => {
                setShowRemittanceModal(true);
                setOpenDropdown(null);
              }}
            >
              {sub.label}
            </div>
          ) : sub.isModal ? (
            <div
              className={classes.dropdownItem}
              onClick={() => {
                setShowLoanModal(true);
                setOpenDropdown(null);
              }}
    >
      {sub.label}
    </div>
    ) : sub.customAction ? (   // ✅ Handles items like Monthly Remittance Upload - Excel
  <div
    key={index}
    className={classes.dropdownItem}
    onClick={() => {
      sub.customAction();       // 👈 call the function defined in dropdownMenus
      setTimeout(() => setOpenDropdown(null), 100); // optional delay to prevent premature close
    }}
          >
            {sub.label}
          </div>
          ) : (
            <NavLink
              to={sub.path}
              onClick={() => setOpenDropdown(null)}
              className={({ isActive }) =>
                `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
              }
            >
              {sub.label}
            </NavLink>
          )}
        </div>
      )
    )}

      </div>
    )}

      </div>
    ) : (
      <Link to={item.path} key={item.label} className={classes.link}>
        <div
          className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
        >
          <img
            src={isActive ? item.activeIcon : item.icon}
            alt={`${item.label} icon`}
            className={classes.dshbrdicon}
          />
          <p className={isActive ? classes.activeText : ''}>{item.label}</p>
        </div>
      </Link>
    );
  })}
      </div>
<Modal show={showTypeModal} onHide={handleCloseTypeModal} centered style={{ zIndex: 9999 }}>
  <Modal.Header closeButton>
    <Modal.Title>Select Payable Type</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="d-flex flex-column gap-2">
      <Button className={classes.sabtn}  onClick={() => handleSelectType("Salary")}>
        Salary Payable
      </Button>
      <Button className={classes.btnpayab}  onClick={() => handleSelectType("Pension")}>
        Pension / PAYE Payable
      </Button>
    </div>
  </Modal.Body>
</Modal>

{/* Step 2: Upload Form */}
<Modal show={showFormModal} onHide={handleCloseFormModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>
      {payableType === "Salary"
        ? "Upload Salary Payable"
        : "Upload Pension / PAYE Payable"}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        console.log("Submit", payableType);
        handleCloseFormModal();
      }}
    >
      {payableType === "Salary" && (
        <a style={{  }} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                                    <Button
                                      className={classes.btntemp}
                                      style={{ width: 200, height: "30px", padding: "0", borderRadius: 5, marginBottom: 10}}  >
                                      Download Template
                                    </Button>
                                  </a>
        )}
        {payableType === "Pension" && (
        <a style={{ marginLeft: 10 }} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                                    <Button
                                      className={classes.btntemp}
                                      style={{ width: 200, height: "30px", padding: "0", borderRadius: 5 , marginBottom: 10}} variant='success' >
                                      Download Template
                                    </Button>
                                  </a>
        )}
        <Modal.Footer />
      <Form.Group className="mb-3">
        
        <Form.Label>Payable Account</Form.Label>
         <Select isLoading={loading} options={debit2} onChange={handlePayables}  placeholder='Select Payable Account' 
                                                        menuPortalTarget={document.body}
                                                        styles={{ width: '80vh',
        
                                                          menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh' }),
                                                          menu: (provided) => ({
                                                            ...provided,
                                                            maxHeight: '300px',
                                                            maxWidth: '700px',
                                                            overflowY: 'auto',
                                                            marginLeft: '20px',
                                                          }),
                                                        }}
                                                      />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Expenses Account</Form.Label>
        <Select isLoading={loading} options={debit1} onChange={handledExpenses}  placeholder='Select Expenses Account' 
                                    menuPortalTarget={document.body}
                                    styles={{
        
                                      menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh'}),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: '300px',
                                        maxWidth: '700px',
                                        overflowY: 'auto',
                                      }),
                                    }}
                                  />
      </Form.Group>

      {payableType === "Pension" && (
        <Form.Group className="mb-3">
          <Form.Label>Select PFA/Tax Agents</Form.Label>
          <Select
                                    value={selectedBeneficiary}
                                      onChange={setSelectedBeneficiary}
                                      options={tableData}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: '300px',
                                          maxWidth: '300px',
                                          overflowY: 'auto',
                                        }),
                                      }}
                                    />
        </Form.Group>
      )}

      <Form.Group className="mb-3">
        <Form.Label>Date</Form.Label>
        <Form.Control type="date"  min={minDate}
                max={maxDate}  value={date} onChange={(e) => setDate(e.target.value)} required />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>File</Form.Label>
        <Form.Control
                                              type="file"
                                              placeholder="Choose file"
                                              accept=".xlsx"
                                              onChange={handleImageChangessss}
        
                                            />
      </Form.Group>

      

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={handleCloseFormModal}>
          Cancel
        </Button>
        <Button style={{ background: "linear-gradient(to bottom, var(--primary-color), var(--light-primary))"}} onClick={payableType === "Salary" ? uploadStatement : uploadStatements}  >
          {createLoading ? (
                                              <>
                                                <Spinner size='sm' />
                                                <span style={{ marginLeft: '5px' }}>Uploading, Please wait...</span>
                                              </>
                                            ) : (
                                              "Upload"
                                            )}
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

          <Modal show={showCustomer} onHide={handleCloseCustomer} animation={false}>
                                <Modal.Header closeButton>
                                  <Modal.Title>Upload Loan</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Form style={{ marginTop: 20 }}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    
                                    {/* <div style={{ marginTop: 10 }}>
                                    
                                              <label for="example-text-input" style={{textAlign: "right"}}>Select Account</label>
                                              <div style={{width:'100%'}}>
                                                <Select
                                                    value={banks.find((b) => b.value === selectedBank) || null}
                                                  onChange={(selectedOption) => handleBankChange(selectedOption)}
                                                  options={banks}
                                                  menuPortalTarget={document.body}
                                                  styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    menu: (provided) => ({
                                                      ...provided,
                                                      maxHeight: '400px',
                                                      overflowY: 'auto',
                                                    }),
                                                  }}
                                                />
                                              </div>
                                             
                                    
                                      </div> */}
          
                                     
          
                                      <div style={{ marginTop: 10 }} >
                                      {/* <div className={`${classes.formFlex} ${classes.formFlex2}`}> */}
                                <label for="example-text-input" style={{ textAlign: "right" }}>Loan Type</label>
                                <div style={{ width: '100%' }}>
                                  <Select
                                    // value={selectedLoan}
                                    value={loans.find((l) => l.value === selectedLoan) || null}
                                    onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                                    options={loans}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: '400px',
                                        overflowY: 'auto',
                                      }),
                                    }}
                                  />
                                </div>
                              {/* </div> */}
                                      </div>
          
                                      <div style={{marginTop: 10, marginLeft: 7}}>
                                    <Form.Label>File  
                                    {/* <span style={{marginLeft: 8}}><a href="https://account-api.patna.ng/api/v1/download-staff-loan" download>
                           <span style={{cursor: "pointer", fontStyle: "italic" }}>Downoload Template</span>
                          </a>
                                    </span> */}
                                    </Form.Label>
                                                <Form.Control
                                                  type="file"
                                                  placeholder="Choose file"
                                                  accept=".xlsx, .xls"
                                                  onChange={handleImageChange}
                                                />
                                  </div>
                                     
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>
          
                                <Modal.Footer>
                                  <Button variant="danger" onClick={handleCloseCustomer}>
                                    Go back
                                  </Button>
                                  <Button variant="success" 
                                  onClick={createLoans}
                                  >
                                    {loading ? (
                                      <>
                                        <Spinner size='sm' />
                                        <span style={{ marginLeft: '5px' }}>Uploading Loan, Please wait...</span>
                                      </>
                                    ) : (
                                      "Upload Loan"
                                    )}
                                  </Button>
                                </Modal.Footer>
                              </Modal>

<Modal size='lg' show={showLoanModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Loan Disbursement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
          <p style={{
            fontWeight: 'bold',
            marginBottom: 10,
            fontSize: 16,
            color: '#000'
          }}>Upload Loan Disbursement</p>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 10,
            marginBottom: 10
          }}>
          <div>
                    <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="download-tooltip">
                  Click here to download template
                </Tooltip>
              }
            >
              <a href="https://account-api.patna.ng/api/v1/download-staff-loan-disbursement" download>
              <div style={{
                width: 200,
                height: 40,
                borderRadius: 8,
                backgroundColor: '#fff',
                border: '1px solid rgb(187, 183, 183)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <p style={{
              marginTop: -3,
                
                  color: '#000'
                }}>Download Template</p>
              </div>
                 {/* <i className="fa fa-download" style={{ color: "#3770ab",  borderColor: "#3770ab", borderRadius: 5, fontSize: 23, cursor: "pointer", marginTop: 7 }}></i> */}
              </a>
            </OverlayTrigger>
                    </div>
                      <div>
                      <OverlayTrigger
                    placement="top"
                    className={classes.btndf1}
                    overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to upload loan</Tooltip>}
                  >
                    <Button variant='success' className={classes.btn2}  onClick={handleShowCustomer} >
                      Upload Loan
                    </Button>
                  </OverlayTrigger>
                      </div>

                      {/* <Button variant="success" onClick={handleCreate} className={classes.btn1}>  Create New Loan  </Button> */}
                      </div>
                <Modal.Footer />
      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="transactionDate">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Transaction Date
              </Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={selectedDatess}
                onChange={handleDateChangess}
                min={minDate}
                max={maxDate}
                required
                style={{ flex: 1 }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="member">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Member
              </Form.Label>
              <div style={{ flex: 1 }}>
                <Select
                  onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                  options={selectOptions}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      overflowY: 'auto',
                    }),
                    control: (provided) => ({
                      ...provided,
                      width: '100%',
                    }),
                  }}
                />
              </div>
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="loanType">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Loan Type
              </Form.Label>
              <div style={{ flex: 1 }}>
                <Select
                  onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                  options={loans}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '200px',
                      overflowY: 'auto',
                    }),
                    control: (provided) => ({
                      ...provided,
                      width: '100%',
                    }),
                  }}
                />
              </div>
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="principalAmount">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Principal Amount
              </Form.Label>
              <CurrencyInput
                name="principal amount"
                decimalsLimit={2}
                className="form-control"
                value={principalAmount}
                onValueChange={handleValueChange}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="loanInterest">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Loan Interest
              </Form.Label>
              <CurrencyInput
                name="loan interest"
                decimalsLimit={2}
                className="form-control"
                value={loanInterest}
                disabled
                onValueChange={handleValueChange1}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="interest">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Interest
              </Form.Label>
              <CurrencyInput
                name="interest"
                decimalsLimit={2}
                className="form-control"
                value={interest}
                disabled
                onValueChange={handleValueChange2}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="totalRepayment">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Total Repayment
              </Form.Label>
              <CurrencyInput
                name="total repayment"
                decimalsLimit={2}
                className="form-control"
                value={totalRepayment}
                disabled
                onValueChange={handleValueChange3}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="duration">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Duration (Months)
              </Form.Label>
              <Form.Control
                type="text"
                name="duration"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                required
                style={{ flex: 1 }}
              />
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="monthlyDeduction">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Monthly Deduction
              </Form.Label>
              <CurrencyInput
                name="monthly deduction"
                decimalsLimit={2}
                className="form-control"
                value={monthlyDeduction}
                disabled
                onValueChange={handleValueChange4}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="selectBank">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Select Bank
              </Form.Label>
              <div style={{ flex: 1 }}>
                <Select
                  value={selectedBanks}
                  onChange={(selectedOption) => handleBankChange(selectedOption)}
                  options={banks}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '200px',
                      overflowY: 'auto',
                    }),
                    control: (provided) => ({
                      ...provided,
                      width: '100%',
                    }),
                  }}
                />
              </div>
            </div>
          </Form.Group>
        </div>
      </div>

      {/* Commented-out Cheque No. field */}
      {/* <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="chequeNo">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Cheque No.
              </Form.Label>
              <Form.Control
                type="text"
                name="cheque no"
                value={cheque}
                onChange={(e) => setCheque(e.target.value)}
                required
                style={{ flex: 1 }}
              />
            </div>
          </Form.Group>
        </div>
      </div> */}
    </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
         <Button style={{ borderRadius: 0 }} variant='success' onClick={createLoan} >
                       {createLoading ? (
                         <>
                           <Spinner size='sm' />
                           <span style={{ marginLeft: '5px' }}>Creating, Please wait...</span>
                         </>
                       ) : (
                         "Create New Loan"
                       )}
                     </Button>
        </Modal.Footer>
      </Modal>
<Modal  size="xl" show={showRemittanceModal}  onHide={() => setShowRemittanceModal(false)} animation={false}>
<div style={{
  background: '#fff',
    borderRadius: 10,
    padding: '20px',
    width: '100%',
    maxWidth: 1200,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
}}>      
<div style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}}>
          <Modal.Title  style={{fontSize: 18, fontWeight: 'bold', marginBottom: 4}}>Add Remittance Receipt</Modal.Title>
          <IoMdCloseCircleOutline onClick={() => setShowRemittanceModal(false)} size={20} style={{color: 'blue', cursor: 'pointer'}}/>
          </div>
           <p style={{fontSize: 13, color: '#555', marginBottom: 20}}>
                        Make Customers' Payments and Record Receipts
                      </p>
       
        <Modal.Body>
       <Form>
  {/* Row 1 */}
  <Row style={{ paddingBottom: 15, fontSize: "12px" }}>
      <Col md={2}>

        <label>
          Transaction Date
        </label>
        <Form.Control
          type="date"
          value={selectedDated}
          onChange={handleDateChangedd}
          style={{ fontSize: 12, marginTop: 10 }}
        min={minDate}
        max={maxDate}
        />
     
    </Col>

    <Col md={3}>
      
        <Form.Label  >
          Invoice Number
        </Form.Label>
        <Select
          onChange={handleSalesChange}
          options={roless}
          menuPortalTarget={document.body}
          styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                control: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  minHeight: "32px", 
                  height: "32px", 
                  // padding: "0 4px", 
                  borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                }),

                valueContainer: (base) => ({
                  ...base,
                  // padding: "0 6px", // reduce vertical padding inside the box
                  height: "28px",
                }),

                indicatorsContainer: (base) => ({
                  ...base,
                  height: "28px",
                }),

                option: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                  color: "black",
                }),

                menuList: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
          }}
        />
     
    </Col>

      <Col md={3}>
      
        <Form.Label >
          Total Amount
        </Form.Label>
        <CurrencyInput
          name="amount"
          decimalsLimit={2}
          className="form-control"
          value={amount}
          disabled
          style={{
            textAlign: "right",
            border: "1px solid #e4e4e4",
            fontSize: 12,
          }}
        />
      
    </Col>

     <Col md={4}>
     
        <Form.Label  >
          Description
        </Form.Label>
       <Form.Control
                          as="textarea"
                          rows={1}
                          disabled
                          placeholder="Enter Description"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          style={{ width: "97%", fontSize: 12 }}
                        />
  
    </Col>

    

    
  </Row>

  {/* Row 2 */}
  <Row style={{ paddingBottom: 15, fontSize: "12px" }}>
   

 <Col md={3}>
      
        <Form.Label >
          Outstanding
        </Form.Label>
        <CurrencyInput
          name="amount"
          decimalsLimit={2}
          className="form-control"
          value={outstanding}
          disabled
          style={{
            textAlign: "right",
            border: "1px solid #e4e4e4",
            fontSize: 12,
          }}
        />
      
    </Col>

    <Col md={3}>
      
        <Form.Label >
          Payment Mode
        </Form.Label>
        <Form.Select
          value={selectedPaymentMode}
          onChange={handlePaymentModeChange}
          style={{ fontSize: 12 }}
        >
          <option value="">Select Mode</option>
          {paymentMethod.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </Form.Select>
      
    </Col>

<Col md={3}>
     
        <Form.Label >
          Bank
        </Form.Label>
        <Select
          onChange={handlePaymentChange}
          options={
            selectedPaymentMode === "1" || selectedPaymentMode === "3"  || selectedPaymentMode === "2"
              ? debit3
              :  selectedPaymentMode === "4"
              ? debit4
              : debit3
          }
          menuPortalTarget={document.body}
           styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                control: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  minHeight: "32px", 
                  height: "32px", 
                  // padding: "0 4px", 
                  borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                }),

                valueContainer: (base) => ({
                  ...base,
                  // padding: "0 6px", // reduce vertical padding inside the box
                  height: "28px",
                }),

                indicatorsContainer: (base) => ({
                  ...base,
                  height: "28px",
                }),

                option: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                  color: "black",
                }),

                menuList: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
          }}
        />
      
    </Col>

    <Col md={3}>
      
        <Form.Label >
          Cheque / Teller No
        </Form.Label>
        <Form.Control
          type="text"
          value={teller}
          onChange={(e) => setTeller(e.target.value)}
          style={{ fontSize: 12 }}
        />
      
    </Col>
    
  </Row>


</Form>

        </Modal.Body>

        <div className={classes.mainTable} style={{ paddingBottom: 30 }}>
                  <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto', }}>
                    <table className="table display bg-white m-0 card-table">
                      <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                        <tr style={{ padding: "2px 10px", margin: "2px 10px", fontSize: 13 }}>
                          <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "10%", padding: "7px 10px", margin: "7px 10px"}}>Item</th>
                          <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px"}}>Total Amount(N)</th>
                          <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px"}}>Outstanding(N)</th>
                          {/* <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px"}}>Debit</th> */}
                          <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px"}}>Amount to Pay(N)</th>
                        </tr>
                      </thead>
                      <tbody>
                      {selectedInv?.map((item, index) => (
                      <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px", fontSize: 12 }}>
                        <td style={{ padding: "2px 10px", margin: "2px 10px", whiteSpace: 'nowrap' }}>
                          {item.item?.gl_name}
                        </td>
                        <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                          {parseFloat(item?.amount).toLocaleString('en-US', {
                            minimumIntegerDigits: 1,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </td>
                        {/* <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>0.00</td> */}
                        <td style={{ padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item?.balance).toLocaleString('en-US', {
                            minimumIntegerDigits: 1,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </td>
                        <td style={{ width: 50 }}>
                          <CurrencyInput
  name={`amount_to_pay_${index}`}
  decimalsLimit={2}
  // Use row.balance as the default if amountsToBePaid[row?.id] is empty or undefined
  value={amountsToBePaid[item?.id] ? amountsToBePaid[item?.id] : item?.balance}
  onValueChange={(value) => handleAmountChange(value, item?.id)}
  className="form-control"
  disabled={item?.balance === "0.00"}
  style={{ textAlign: "right", border: "1px solid #c4c4c4", height: 30, fontSize: 12 }}
/>
</td>
                      </tr>
                      ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                 <Row style={{
                  display: 'flex',
                  justifyContent: 'flex-end'
                 }}>
                          <Col md={6} xs={6}>
                            {/* <Button className={classes.submitBtn} onClick={addLine} disabled>
                              + Add Line
                            </Button> */}
                          </Col>
                          <Col md={6} xs={6}>
                            {/* <Button className={classes.submitBtn} onClick={addLine} disabled>
                              + Add Line
                            </Button> */}
                          </Col>
                          <Col md={3} xs={3}>
  <div
    style={{
      background: '#f5f7fb',
      padding: '10px',
      borderRadius: '8px',
      textAlign: 'right',
      fontSize: '12px',
      marginBottom: '15px',
     

    }}
  >
    <span style={{ display: 'block' }}>Total Amount</span>
    <strong style={{ display: 'block' }}>
      {totalAmountToPay.toFixed(2)}
    </strong>
  </div>
</Col>

                          
                        </Row>
      
         <div style={{
            display: 'flex',
    justifyContent: 'flex-end',
    gap: 10
         }}>
                  
                  <button style={{
                    background: '#f5f7fb',
    border: 'none',
    padding: '6px 14px',
    borderRadius: '6px',
    cursor: 'pointer'
                  }} >Print</button>

                  <Button className={classes.btnss} variant='primary' 
                  disabled={!selectedInvoice || paymentLoading}
               onClick={createPayment}>
                  {paymentLoading ? (
    <>
      <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className="me-2"
      />
      Submitting Remittance...
    </>
  ) : (
    "Submit Remittance"
  )}
                    
                </Button>
                  
                </div>
        
                
          
                        

       
        {create && (
              <div className={classes.overlay}>
                <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
              </div>
            )}
            </div> 
      </Modal>
      <RemitanceUpload isOpen={showRemittanceExcelModal} onClose={() => setShowRemittanceExcelModal(false)} animation={false}/>
      <Modal size='lg' >
  <Modal.Header closeButton>
    <Modal.Title style={{fontSize: 16, fontWeight: 'bold'}}>Remittance - Excel Upload</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      {/* Row 1 */}
      <Row className="g-3">
          <Col md={4} sm={12}>
          <Form.Group controlId="transactionDate" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Transaction Date</Form.Label>
            <Form.Control
              type="date"
              onChange={handleDateChange}
              value={selectedDate}
              min={minDate}
              max={maxDate}
            />
          </Form.Group>
        </Col>

        <Col md={4} sm={12}>
          <Form.Group controlId="customer" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Customer</Form.Label>
            <Select
              onChange={handleCustomerChange}
              options={cus}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </Col>

      

        {/* <Col md={4} sm={12}>
          <Form.Group controlId="paymentMode" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Payment Mode</Form.Label>
            <Form.Select
              value={selectedPaymentMode}
              onChange={handlePaymentModeChange}
              style={{ fontSize: 14 }}
            >
              <option value="">Select Mode</option>
              {paymentMethod.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col> */}
        <Col md={4} sm={12}>
          <Form.Group controlId="bank" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Bank</Form.Label>
            <Select
              onChange={handlePaymentChange}
              options={
               debit3
              }
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row className="g-3">
        

        <Col md={4} sm={12}>
          <Form.Group controlId="tellerNo" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Cheque/Teller No</Form.Label>
            <Form.Control
              type="text"
              value={teller}
              onChange={(e) => setTeller(e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col md={4} sm={12}>
          <Form.Group controlId="uploadExcel" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Upload Excel File</Form.Label>
            <Form.Control
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setExcelFile(e.target.files[0])}
            />
          </Form.Group>
        </Col>
      </Row>

      <Modal.Footer />
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="light" className={classes.btn1} onClick={() => setShowRemittanceExcelModal(false)}>Cancel</Button>
    <Button className={classes.btnss} variant="primary" onClick={uploadRemittance}>
      Upload
    </Button>
  </Modal.Footer>
   {createLoading && (
              <div className={classes.overlay}>
                <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
              </div>
            )}
   
</Modal>

      {/* User section */}
      <div className={`${classes.user} ${classes.desktopOnly}`}>
        {/* <img src={usrnoti} className={classes.bellnoti} alt="Notification" /> */}
        <div className={classes.userProfile} ref={userDropdownRef}>
          <div
            className={classes.userAvatar}
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
          >
            <p className={classes.usrnm}>
              {initials}
            </p>
          </div>

          {/* User dropdown menu */}
          {userDropdownOpen && (
            <div className={classes.userDropdown}>
              <div className={classes.userInfo}>
                <p className={classes.userName}>{user || 'User'}</p>
                {/* <p className={classes.userName}>Base Currency: {defaultCur || 'Nil'}</p> */}
                <p className={classes.userEmail}>{userEmail || 'user@example.com'}</p>
              </div>
              <div className={classes.dropdownDivider}></div>
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  setShowChangePassword(true);
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Change Password
              </button>
              
              <button onClick={() => navigate("/welcome")}
              className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
              >
              <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Switch Account
              </button>
              <button onClick={() => setShowProfile(true)}
              className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
              >
              <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Organization Settings
              </button>
              {admin !== 'Super Admin' && (
              <>
              <button
                className={classes.dropdownItemm}
                onClick={() => {
                 handleTrashClick1();
                  setMobileMenuOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Change Working Month
              </button>
              </>
              )}

              <button
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  handleLogout();
                  setUserDropdownOpen(false);
                  // Redirect to signin page after logout
                  // window.location.href = "/signin";
                }}
              >
                <img src={stngs} alt="Logout" className={classes.dropdownIcon} />
                Logout
              </button>
            </div>
          )}
       
        </div>
      </div>
      <div className={classes.mobileOnly}>
    <button
      className={classes.hamburgerBtn}
      onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
    >
      {isMobileMenuOpen ? <FaRegTimesCircle /> : <CiMenuFries />}
    </button>
  </div>
       {isMobileMenuOpen && (
        <div className={classes.mobileMenu}>
          <div className={classes.mobileMenuContent}>
            {/* All Navigation Links */}
            <div className={classes.mobileNav}>
             {filteredNavItems.map((item) => {
  const isActive = location.pathname.startsWith(item.path);
  const hasDropdown = dropdownMenus[item.label];

  // filter submenu permissions same as desktop
  const filteredDropdownItems = hasDropdown
    ? dropdownMenus[item.label].filter((sub) => {
        if (item.label === "Accounting") {
          return permissions.includes(sub.permission);
        } else {
          return permissions.includes(sub.permission);
        }
      })
    : [];

  return hasDropdown && filteredDropdownItems.length > 0 ? (
    <div key={item.label} className={classes.mobileNavGroup}>
      {/* parent clickable */}
      <div
        className={`${classes.mobileNavItem} ${
          isActive ? classes.activeDropdown : ""
        }`}
        onClick={() =>
          setOpenDropdown(openDropdown === item.label ? null : item.label)
        }
      >
        {item.label}
      </div>

      {/* submenu collapsible */}
      {openDropdown === item.label && (
        <div className={classes.mobileSubmenu}>
          {filteredDropdownItems.map((sub, index) =>
            sub.isUploadPayableModal ? (
              <div
                key={index}
                style={{ cursor: "pointer" }}
                className={classes.mobileSubmenuItem}
                onClick={() => {
                  handleOpenUploadType();
                  setOpenDropdown(null);
                  setMobileMenuOpen(false);
                }}
              >
                {sub.label}
              </div>
            ) : sub.isModal ? (
              <div
                key={index}
                className={classes.mobileSubmenuItem}
                onClick={() => {
                  setShowLoanModal(true);
                  setOpenDropdown(null);
                  setMobileMenuOpen(false);
                }}
              >
                {sub.label}
              </div>
            ) : (
              <NavLink
                key={index}
                to={sub.path}
                onClick={() => {
                  setOpenDropdown(null);
                  setMobileMenuOpen(false);
                }}
                className={({ isActive }) =>
                  `${classes.mobileSubmenuItem} ${
                    isActive ? classes.activeDropdown : ""
                  }`
                }
              >
                {sub.label}
              </NavLink>
            )
          )}
        </div>
      )}
    </div>
  ) : (
    <NavLink
      key={item.label}
      to={item.path}
      onClick={() => setMobileMenuOpen(false)}
      className={({ isActive }) =>
        `${classes.mobileNavItem} ${isActive ? classes.activeDropdown : ""}`
      }
    >
      {item.label}
    </NavLink>
  );
})}

            </div>

            {/* Profile Section inside mobile menu */}
            <div className={classes.mobileProfile}>
              <p className={classes.userName}>{user || "User"}</p>
              <p className={classes.userEmail}>{userEmail || "user@example.com"}</p>

              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  setShowChangePassword(true);
                  setMobileMenuOpen(false);
                }}
              >
                Change Password
              </button>
              <button onClick={() => navigate("/welcome")}
              className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
              >
              <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Switch Account
              </button>
              <button onClick={() => setShowProfile(true)}
              className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
              >
              <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Organization Settings
              </button>

 {admin !== 'Super Admin' && (
              <>
              <button
                className={classes.dropdownItemm}
                onClick={() => {
                 handleTrashClick1();
                  setMobileMenuOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Change Working Month
              </button>
              </>
              )}
              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
              >
                Logout
              </button>
            </div>
          </div>
           
        </div>
      )}
          <Modal
      show={showProfile}
      onHide={() => setShowProfile(false)}
      centered
      size="lg"
      scrollable
      className="org-modal"
    >
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: 20}} >
        <Modal.Title style={{
          color: '#111827',
    fontSize: '18px',
    fontWeight: 700,
    margin: 0,
    textAlign: 'left'
        }}>
          Organization Settings
        </Modal.Title>
         <p style={{ marginTop: "-5px",
          color:"#6b7280",
    fontSize: "13px",
    textAlign: 'left'
          }}>
          Update organization details — name, address, logo, contact and defaults for billing/timezone.
        </p>
      </div>

      <Modal.Body style={{ padding: "1.5rem 2rem" }}>
       

        <Form>
          {/* Organization Name */}
          <Form.Group className="mb-3">
            <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Province name</Form.Label>
            <Form.Control
            style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
            }}
             value={provinceName}
              onChange={(e) => setProvinceName(e.target.value)}
            type="text" placeholder="Enter name" />
          </Form.Group>

          {/* Email + Phone */}
          <Row>
            <Col md={7}>
              <Form.Group className="mb-3">
                <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Support email</Form.Label>
                <Form.Control style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",

            }}
             value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
            type="email" placeholder="Enter support email" />
              </Form.Group>
            </Col>
            <Col md={5}>
              <Form.Group className="mb-3">
                <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Phone</Form.Label>
                <Form.Control style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",

            }}
            value={userPhone}
          onChange={(e) => setUserPhone(e.target.value)}
            type="text" placeholder="+234..." />
              </Form.Group>
            </Col>
          </Row>

          {/* Address */}
          <Form.Group className="mb-3">
            <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Address</Form.Label>
            <Form.Control
            style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",

            }}
            value={address}
              onChange={(e) => setAddress(e.target.value)}
              as="textarea"
              rows={2}
              placeholder="Enter address"
            />
          </Form.Group>

          <Row>
            {/* Industry */}
            {/* <Col md={7}>
              <Form.Group className="mb-3">
                <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Industry</Form.Label>
                <Form.Control style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",

            }}
            value={industry}
                  onChange={(e) => setIndustry(e.target.value)}
            type="text" placeholder="Industry" />
              </Form.Group>
            </Col> */}

            {/* Tax ID */}
            {/* <Col md={5}>
              <Form.Group className="mb-3">
                <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Tax ID</Form.Label>
                <Form.Control style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",

            }}
            value={taxId}
                  onChange={(e) => setTaxId(e.target.value)}
            type="text" placeholder="Tax ID" />
              </Form.Group>
            </Col> */}
          </Row>

          <Row>
            {/* Currency */}
            <Col md={7}>
              <Form.Group className="mb-3">
                <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }} >Default currency</Form.Label>
                {/* <Form.Select
                value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",

            }}>
                  <option>₦ NGN - Nigeria</option>
                  <option>$ USD - United States</option>
                </Form.Select> */}

                <Select
  
  value={tempDefaultOption}     // show string before user selects
  onChange={(selected) => {
    // selected will be from real API currency options
    setDefaultCur(selected.label);     // or set whole object if needed
    localStorage.setItem("defaultCurrency", selected.label);
    handleCurrencyChange(selected);
  }}
  options={optionsWithDefault}
  formatOptionLabel={(option) => (
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <span style={{ fontSize: "12px" }}>{option.label}</span>
      <span style={{ fontSize: "12px", lineHeight: "1" }}>-</span>
      <span style={{ color: "#888", fontSize: "12px" }}>{option.country}</span>
    </div>
  )}
  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: "35px",
      height: "35px",
      width: "100%",
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",           // 🔧 FIXED prevent multi-line wrap
      overflow: "hidden",           // 🔧 FIXED keep text inside container
      textOverflow: "ellipsis",     // 🔧 FIXED truncate long text gracefully
      whiteSpace: "nowrap",  
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "30px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    })
  }}
/>

              </Form.Group>
            </Col>

            {/* Timezone */}
            <Col md={5}>
              <Form.Group className="mb-3">
                <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Timezone</Form.Label>
                <Form.Select
                value={timezone}
                  onChange={(e) => setTimezone(e.target.value)}
                style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
            }}>
                  {timezoneList.map((tz) => (
        <option key={tz.offset} value={tz.description} >
          {tz.offset} - {tz.description}
        </option>
      ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
{/* <Col md={7}> */}
              {/* <Form.Group className="mb-4">
            <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Organization logo</Form.Label>
            <div className="d-flex align-items-center gap-3">
              <img
                src="/placeholder-avatar.jpg"
                alt="Logo"
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
              <div>
                <Button variant="secondary" className="me-2">Choose file</Button>
                <Button variant="outline-danger">Remove</Button>
              </div>
            </div>
          </Form.Group> */}
           {/* </Col> */}
            {/* Currency */}
            <Col md={5}>
              <Form.Group className="mb-3">
            <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>Cheque Size Selection</Form.Label>
            <Form.Select
      style={{
        color: '#111827',
        display: 'block',
        fontSize: '13px',
      }}
      value={chequeSize}
      onChange={(e) => {
        setChequeSize(e.target.value);
        storeChequeSize(e.target.value); // Store on change
      }}
    >
      <option value="">Select cheque size</option>
      <option>9.9cm x 17cm</option>
      <option>10cm x 17cm</option>
      <option>10.1cm x 17cm</option>
    </Form.Select>
          </Form.Group>
            </Col>

          </Row>

          {/* Logo */}
        


          {/* Notes / Footer */}
          <Form.Group className="mb-3">
            <Form.Label style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",
    marginBottom: "6px",
            }}>
              Notes / Invoice footer
            </Form.Label>
            <Form.Control
            style={{
              color:" #111827",
    display: "block",
    fontSize: "13px",

            }}
              as="textarea"
              rows={2}
              placeholder="Enter footer notes"
              value={footerNotes}
              onChange={(e) => setFooterNotes(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowProfile(false)}>
          Cancel
        </Button>
        <Button style={{backgroundColor: '#174384' }} onClick={changeProfile}>
        {createLoading1 ? (
                                      <>
                                        <Spinner size='sm' />
                                        <span style={{ marginLeft: '5px' }}>Saving, Please wait...</span>
                                      </>
                                    ) : (
                                      "Save Changes"
                                    )}
        </Button>
      </Modal.Footer>
    </Modal>
 <Modal 
  show={showChangePassword} 
  onHide={() => setShowChangePassword(false)} 
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Change Password</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>

      {/* CURRENT PASSWORD */}
      <Form.Group className="mb-3" style={{ position: "relative" }}>
        <Form.Label>Current Password</Form.Label>
        <Form.Control
          type={showCurrent ? "text" : "password"}
          placeholder="Enter current password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />

        <span
          onClick={() => setShowCurrent(!showCurrent)}
          style={{
            position: "absolute",
            right: 10,
            top: 40,
            cursor: "pointer",
            color: "#666"
          }}
        >
          {showCurrent ? <EyeOff size={18} /> : <Eye size={18} />}
        </span>
      </Form.Group>

      {/* NEW PASSWORD */}
      <Form.Group className="mb-3" style={{ position: "relative" }}>
        <Form.Label>New Password</Form.Label>
        <Form.Control
          type={showNew ? "text" : "password"}
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <span
          onClick={() => setShowNew(!showNew)}
          style={{
            position: "absolute",
            right: 10,
            top: 40,
            cursor: "pointer",
            color: "#666"
          }}
        >
          {showNew ? <EyeOff size={18} /> : <Eye size={18} />}
        </span>
      </Form.Group>

      {/* CONFIRM PASSWORD */}
      <Form.Group style={{ position: "relative" }}>
        <Form.Label>Confirm Password</Form.Label>
        <Form.Control
          type={showConfirm ? "text" : "password"}
          placeholder="Confirm new password"
          value={passwordConfirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
        />

        <span
          onClick={() => setShowConfirm(!showConfirm)}
          style={{
            position: "absolute",
            right: 10,
            top: 40,
            cursor: "pointer",
            color: "#666"
          }}
        >
          {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
        </span>
      </Form.Group>

    </Form>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowChangePassword(false)}>
      Cancel
    </Button>

    <Button variant="primary" onClick={changePassword122}>
      {createLoading ? (
        <>
          <Spinner size="sm" />
          <span style={{ marginLeft: "5px" }}>Saving, Please wait...</span>
        </>
      ) : (
        "Save Changes"
      )}
    </Button>
  </Modal.Footer>
</Modal>
<Modal show={showPay} onHide={handleClosePay} size="xl">
     
      <div className={classes.modalContent}>
        <h3 className={classes.title}>Payment - From Payables</h3>
        <div className={classes.topRow}>
         
          <div className={classes.Group}>
  <label>Payment type</label>
  <select
style={{width: 300}}
    value={selectedPayment}
    
    onChange={(e) => {
      setSelectedPayment(e.target.value); // keep it as a string
    }}
  >
    <option value="">Select Type</option>
    <option value="cheque">Cheque</option>
    <option value="bank transfer">Bank Transfer</option>
    <option value="cash">Cash</option>
    
  </select>
</div>
<div />
<div  className={classes.Group}>
  <label>Journal Reference</label>
  <div className={classes.refContainer}>
     {loadingRef ? (
                  <div className={classes.spinnerWrapper}>
                    <Spinner animation="border" size="sm" />
                  </div>
                ) : (
                  <input
                               type="text"
                               value={journalReference}
                               disabled
                              //  onChange={(e) => setJournalReference(e.target.value)}
                               required
                              
                             />
                              )}
  </div>
  
</div>


          <div className={classes.Group}>
            <label>Transaction Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
              // style={{width: 350}}
            />
          </div>

          {/* ✅ Currency dropdown unchanged */}
          <div className={classes.Group}>
            <label>Bank</label>
            <Select
  // value={selectedCurrency}
  onChange={(selectedOption) => handleBankChanges(selectedOption)}
  options={banks}

  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: "35px",
      height: "35px",
      width: "100%",
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",           // 🔧 FIXED prevent multi-line wrap
      overflow: "hidden",           // 🔧 FIXED keep text inside container
      textOverflow: "ellipsis",     // 🔧 FIXED truncate long text gracefully
      whiteSpace: "nowrap",  
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "30px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    })
  }}
/>

          </div>
        </div>

        <h3 className={classes.titles}>Payment Breakdown</h3>
        <table className={classes.table}>
          <thead style={{backgroundColor: "#174384"}}>
            <tr style={{color: '#fff'}}>
              <th>#</th>
              <th>Beneficiary</th>
              <th>Outstanding Amount</th>  {/* ✅ new column */}
              <th>Account</th>
              <th>Amount to Pay</th>
              <th></th>
            </tr>
          </thead>
         <tbody>
        {rows.map((row, index) => (
          <tr key={index}>
            <td>{index + 1}</td>

            {/* Beneficiary Column - React Select */}
           <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
             <Select
  value={beneficiaryOptions.find(opt => opt.value === row.beneficiaryId) || null}
  onChange={(option) => handleBeneficiaryChange(index, option)}
  options={beneficiaryOptions}
  placeholder="Select Beneficiary"
  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: "35px",
      fontSize: "12px",
      borderColor: "#ccc",
      "&:hover": { borderColor: "#999" },
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "12px",
      color: "#999",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "12px",
    }),

    // 🔥 Added: reduce dropdown option font size
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      padding: "6px 10px",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "13px",
    }),
  }}
/>
 {row.documentUrl && (
    <span
      onClick={() => handleOpenDoc(row.documentUrl)}
      style={{
        cursor: "pointer",
        fontSize: "18px",
        color: "#174384"
      }}
      title="View Document"
    >
      👁
    </span>
  )}
            </td>

            {/* Outstanding Amount Column - Disabled Input */}
            <td>
              <CurrencyInput
                name={`outstanding-${index}`}
                value={row.outstandingAmount}
                disabled
                className={`form-control ${classes.currencyInput}`}
                style={{
                  textAlign: "right",
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                  border: "1px solid #ddd",
                  height: "35px",
                  fontSize: "12px",
                }}
                decimalsLimit={2}
              />
            </td>

            {/* Account Column - React Select */}
            <td>
              <Select
             value={(row.accountOptions || []).find(a => a.value === row.accountId) || null}
  onChange={(selectedOption) => handleAccountChange(index, selectedOption)}
  options={row.accountOptions}
                placeholder="Select Account"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                    minHeight: "35px",
                    fontSize: "12px",
                    borderColor: "#ccc",
                    "&:hover": { borderColor: "#999" },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "12px",
                    color: "#999",
                  }),
                  option: (base, state) => ({
      ...base,
      fontSize: "13px",
      padding: "6px 10px",
    }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "12px",
                  }),
                }}
              />
            </td>

            {/* Amount to Pay Column - Currency Input */}
            <td>
              <CurrencyInput
                name={`amount-${index}`}
                value={row.amountToPay}
                onValueChange={(value) => handleAmountChanges(index, value)}
                className={`form-control ${classes.currencyInput}`}
                style={{
                  textAlign: "right",
                  border: "1px solid #ccc",
                  height: "35px",
                  fontSize: "12px",
                  paddingRight: "10px",
                }}
                placeholder="0.00"
                decimalsLimit={2}
                allowNegativeValue={false}
              />
            </td>

            <td>
              <button
                onClick={() => removeRow(index)}
                className={classes.removeBtn}
                style={{ marginLeft: "10px" }}
              >
                Remove
              </button>
            </td>
          </tr>
        ))}
      </tbody>
        </table>

        <div className={classes.actionRow}>
           <button className={classes.addLineBtn} onClick={addLine}>
        + Add Line
      </button>
        </div>

        <div className={classes.totalRow}>
          <div className={classes.totalBox}>
            <span style={{whiteSpace: "nowrap"}} >Total Amount</span>
           <strong style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
  {Number(totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
</strong>
          </div>
        </div>

        {/* <form  */}
        {/* // onSubmit={handleSubmit}
        > */}
          <div className={classes.footerButtons}>
            

            {/* <button type="button" className={classes.printBtn} onClick={handlePrinter}>
              Print
            </button> */}

            <button
              type="submit"
              className={classes.submitBtn}
              // disabled={isSaving || !isBalanced}
              onClick={handleFetchPayments}
            >
             
              {isSaving ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner animation="border" size="sm" /> Saving...
                </span>
              ) : (
                "Save Payments"
              )}
            </button>
          </div>
        {/* </form> */}

        <button className={classes.closeBtn} onClick={handleClosePay}>
          ×
        </button>
      </div>

      {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClosePay}>Reset</Button>
        <Button style={{ backgroundColor: '#092147', borderColor: '#092147' }} onClick={() => console.log({ paymentType, paymentTo, date, currency, description, modeOfPayment, debitAccount, totalAmount, loanAccount, reference, lines })}>Save Receipt</Button>
      </Modal.Footer> */}
    </Modal>
<Modal show={showDocModal} onHide={handleCloseDoc} size="xl">
  <div style={{ padding: "20px" }}>
    <h4>Beneficiary Document</h4>
    <button
      onClick={handleCloseDoc}
      style={{
        position: "absolute",
        top: 10,
        right: 20,
        background: "transparent",
        border: "none",
        fontSize: "24px",
        cursor: "pointer"
      }}
    >
      ×
    </button>

    <iframe
      id="docFrame"
      src={currentDocUrl}
      style={{
        width: "100%",
        height: "500px",
        border: "1px solid #ccc",
        borderRadius: "6px"
      }}
    ></iframe>
  </div>
</Modal>

            <JournalModal
                isOpen={openJournalModal}
                onClose={() => setOpenJournalModal(false)}
            />
    
    </div>
  );
}
